import { createStore } from 'vuex'
import 'es6-promise/auto'
import axios from 'axios'
import EventService from '@/services/EventService.js'
import { useCookies } from "vue3-cookies";
import songs_data from './songs.js';
import search_data from './search.js';

const store = createStore({
  state () {
    return {
      user: null,
      p2puser: null,
      p2puseroffers: null,
      auth2fa: false,
      preLoginData: null, // pre Login data used for 2fa

      nft: false,
      muze: false,
      tickets: false,
      shop: false,

      tickets_nft: [],
      collections_nft: [],
      collections_music: [],
      subscriptions_nft: [],
      userplaylists: [],
      userextplaylists: [],
      userfavsongs: [],
      usercurrentsongs: [],
      usersubcreators: [],
      tracks_1: [
        {
          id: "DEFAULT001",
          timestamp: "2024-12-01 12:12:12",
          title: "Abstract Technology",
          artists: ["NRA-LAB"],
          album: "",
          album_connected: [],
          channel_connected: [],
          explicit_text: 0, // czy jest tekst niecenzuralny/wykluczajacy
          publisher_timestamp: "2024-11-12 12:12:12", // czas publikacji zasobu
          publisher_info: "2024 Muzible", // wydawca zasobu
          similar_songs: [],
          excluded_countries: [],
          description: "Invitation, Unstoppable, Journey music.",
          music_tags: ["magnetic", "emotional", "piano", "sci fi", "india", "krishna", "journey"],
          music_genre: ["Future Bass", "Beats", "Electronic", "Corporate"],
          music_mood: ["Dreamy", "Hopeful", "Bright", "Uplifting"],
          music_movement: ["Floating", "Smooth", "Chasing", "Medium", "Elegant"],
          
          art_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT001.webp",
          art: "https://cdn-img.muzible.com/tracks/default/DEFAULT001_200x200.webp",
          src: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001_160kbps_backup.mp4",
          hlssrc: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001.mpd",
          
          published: 1,
          stream_lvl: 0, // Poziom streama, 0 - darmowy (backup na lvl0 bucket), 1 - platny (backup na lvl1 bucket), 2 - platny Atmos (backup na lvl1 bucket)
          type: "muze", // muze, ticket, geo, global - informacje jak zostal dodany zasob i co zawiera (global to B2B streamy)
          playable: 1, // czy mozna odtworzyc 0 lub 1 - informacja dla playera - dodac mozan tylko utwory Playable. Domyslnie 1 dla muzyki.
          streamable: 1, // czy mozna streamowac 0 lub 1, inaczej albo owner albo creator albo sub(creatora) albo gerolokalizacyjny. Nie da sie zmienic ustawiany raz.
          public: 1, // czy jest publiczny 0 lub 1 - publiczy laduje w buckecie lvl0 oraz lvl0_flac i jest w jednej najlepszej wersji dostepny dla kazdego za darmo.
          // public owner zasobu moze zmienic z 0 na 1 lub z 1 na 0, wywoluje to przekodowanie muzyki i zmiane w bucketach (usuniecie starych i dodanie nowych lokalizacji,
          // podczas zmiany mozan podmienic jakosc utworu. Zmiany moze dokonac tylko creator zasobu i tylko dla obietkow ktore nie sa NFTkami lub Geo - czyli sa Streamowalne (NFT i GEO nie sa).
          stream_count: 0, // ile razy odtworzono, raz dziennie update licznikow
          creator: "Muzible", // tworca zasobu - nie mozan zmienic nigdy.
          creator_sub: 0, // czy creatora mozna subskrybowac 0 lub 1 - muzyka zaladowana ze B2B stream ma kreatora ogolnego, kreatorem moze byc tez Muzible, tacy kreatorzy nie sa subskrybowalni
          owner: "Muzible", // aktualny owner tego zasobu - wykorzystwane dla NFT, Lokalizacyjnych NFT, Ticketow. Takie zasoby sa zazwyczaj handlowalne.
          royalty_free: 1, // czy jest bezplatny jesli 1 to za streamowanie nikt nie placi, tzn ze jest darmowy i creator nie dostanie nic za odtworzenia. Glownie stosowane w NFT oraz publicznych zasobach (lvl0) (takze podcasty)
          stream_pps: 0, // level platnosci za streamowanie - 1 podstawowy, 2 - dla streamow Atmos - creatorzy atmos zarabiaja troche wiecej za odtworzenie.
          nft_is: 0, // jest nftkiem - moze byc NFTkiem streamable - wtedy owner aktualny zgarnia za streamy dzieli streamy (przychody) sie to na N ownerow i creatora.
          nft_totalsize: 0, // rozmiar dropa dla nft (-1) jesli unlimited - informacja o lacznym nakladzie danego NFT, jesli -1 to nie ma limitu 0 moze byc czasowy limit na claim NFT np geo/ticket.
          nft_number: 0, // numer nftka bue wuejszt niz nft_totalsize
          nft_start_price_usd: 0, // cena startowa nftka w usd ustawione na poziomie kolekcji badz osobno per NFT
          nft_start_price_muz: 0, // cena startowa nftka w muz ustawione na poziomie kolekcji badz osobno per NFT
          nft_merch: 0, // czy jest merch O lub 1 - wtedy mozab go uzyc w sklepie. Takie NFTki pojawia sie w Collections jako Merch
          nft_resale_to_creator_percent: 0, // % zysku dla tworcy przy kazdej odsprzedazy, standardowo 10% - mozna zmienic dla kazdego NFTka na od 0 do 50.
          nft_claim_end_time: "", // czas do kiedy mozna claimowac - glownie NFT lokalizacyjne i ticketowe (glownie takie unlimited ale nie musza byc unlimited)
          nft_bonus: 0, // czy jest bonusowy - jesli tak to dodatkowe bonusy dla ownera
          nft_bonus_type: "", // typ bonusu money - przypisane sa MUZy do tego NFTka - w czasie tworzenia przez artyste juz musza byc zdeponowane, podczas claimu/zmiany ownera pierwszy raz owner dostaje bonus
          // inne typy bonusow moga byc dodawane na biezaco i ich obsluga moze byc na poziomie pozniejszego mercha.
          nft_bonus_info: {}, // dodatkowe informacje o bonusie - np. ile MUZy, jakie prawa, jakie inne bonusy, jakie merch itp. info dla Engine bonusow
          nft_bonus_used: 0, // czy bonus juz byl uzyty - jesli tak to nie mozna go juz uzyc, moze zalezec od typu bonusa. Obsluga po stronie backendu tylko. (bonus engine)
          geo_link: "", // link do lokalizacji geo - zobacyzmy gdzie dokladnie - moze google maps czy cos innego..
          geo_time_until: "", // czas do kiedy jest widoczny w geolokacji, jesli pusty to widocznosc bez konca, jesli widocznosc minie to zasob zwraca src: domyslny dzwiek dla wszystkich niedostepnych.
          geo_location_lon: "", // lokalizacja geograficzna
          geo_location_lat: "", // lokalizacja geograficzna
          geo_location_radius: 0, // promien lokalizacji we metrach na jaka odleglosc lapie lokalizacja
          // Geo powinna byc skanowalna albo nie skanowalna - wtedy wystarczy byc w lokalizacji (badz byc ownerem/creatorem),
          // Jak jest nie skanowalny GEO NFT to w lokalizacji mozna odtworzyc ale mozna tez kupic takiego NFT i odtwarzac poza lokalizacja.
          // Jesli skanowalna - trzeba najpierw sie przejsc do lokalizacji i tam zeskanowac i zclaimowac NFTka, wtedy jest juz odtwarzalny poza lokalizacja i mozna nim tez handlowac.
          // W obu przypoadkach, jesli ktos jest w lokalizacji to moze odtworzyc nawte jak nie ma NTka - chyba ze geo_time_until jest przekroczony - wtedy tylko owner/creator.
          // Jesli jest to GEO NFT - to obiekt GEO NFT
          geo_can_play_in_location_non_owner: 1, // czy nie bedac ownerem/creatorem mozna odtworzyc bedac w lokalizacji
          geo_nft_scan: 0, // czy jest skanowana i to wystarcza aby nabyc - trzeba przyjsc do lokalizacji zeskanow i wtedy mozan claimowac NFTka (jesli wciaz dostepny)
          geo_nft_buy: 0, // czy jest kupowalny i mozna kupic przed odtworzeniem - troche w ciemno zostac wlascicielem praw do zasobu (geo nie sa streamowalne!). Wciaz moze byc tak ze
          // po kupnie trzeba przejsc do lokalizacji zeby zeskanowac i zclaimowac NFTka, zasob GEO NFT  moze dawac prawa do odtworzenia muzyki poza lokalizacja, oraz inne dowolne, ale moze tez:
          // podczas Claimu w lokalizacji,
          geo_nfts: [], // jesli jest NFTkiem to lista NFTkow ktore sa wlasnoscia tego obiektu - mozna miec kilka NFTkow na jednym obiekcie
          // Te NFtki sa wczesniej stworzone przez tworce, moga byc playable i non playble, nie moga byc streamable. moga zawierac merch. kazdy GEO NFT ma swoj ID i moze miec przypisane dodatkowe unikatowe NFTki
          // GEO NFt szeruja naotmiast wspolne dane nie zmienialne, tak by czas, dostepnosc, ilosc, lokalizacja zawsze byly te same.
          // Beda w lokalizacji z obiektem geo_nft_scan : 1, pojawi sie lista NFTkow ktore mozna claimowac - nie widzimy co zawieraja (geo_nfts) ale widzimy ile jest NFTkow do claimowania i sami dokonujemy wyboru z dostepnych
          // Wtedy po claimowaniu dostajemy dostep do zasobu i mozemy go odtwarzac poza lokalizacja, ponadto stajemy sie tez ownerem geo_nfts - ktore UWAGA! - moga zawierac dodatki/bonusy(glownie non-playable).
          ai_gen: 0, // informacja czy zasob zostal wygenerowane przez AI (muze engine)
          ai_gen_prompt: "", // informacja jakie byly parametry generacji
          ai_gen_score: 0, // jakosc generacji - 0-100 - ocenia uzytkownik ktory generowal (raz)
          ai_gen_mood: 0, // informacja czy zostal wygenerowany na podstawie zdjecia (muze engine)
          ai_gen_mood_link: "", // link do zdjecia z ktorego generowano muzyke (w muze engine)
          // Lokalizacje plikow wszystkich leveli + lokalizacja oryginalu nie widoczne na zewnatrz - zapisane po skanowaniu i generacji plikow
          nv_link_flac: "",
          nv_link_atmos: "",
          nv_link_768: "",
          nv_link_320: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001.mpd",
          nv_link_backup: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001_160kbps_backup.mp4",
          nv_link_preview: "https://cdn.s0p.muzible.com/DEFAULT001/DEFAULT001_160kbps_preview.mp4",
          nv_link_raw_file: "s3://muzible-music-raw/stream-free/default_music/abstract-technology-pixelated-futures-230634.mp3",
          nv_link_creator: "https://cdn.c0.muzible.com/MUZIBLE/DEFAULT001.mpd",
          nv_has_flac: 0,
          nv_has_atmos: 0,
          nv_has_768: 0,
          nv_has_320: 1,
          nv_has_backup: 1,
          nv_has_preview: 1,
          nv_has_creator: 1, duration: "2:24",

        },
      ],



      referal_source: 'na',
      referal_medium: 'na',
      referal_campaign: 'na',

      // Player settings
      playlistcreation:false, 
      isPlaying:false,
      ismusicloading:false, 
      currentTrackInfo: 0,
      usehls:false, 
      hlsready: false,

      // End Player settings

      // Search
      usersearchresults: null,
      currentTrackIndex: 0,

      // End Search

      // Crypto
      crypto_dashboard_data: null,
      /*crypto_dashboard_data: {"total":10000000,
                              "released":2000009,
                              "burned":1999900,
                              "listed":0,
                              "listing_price":0.6,   
                              "current_price":0.6,                       
                              "release_incoming": 1,
                              "release_amount":1000000,
                              "release_amount_left":99000,
                              "release_price":0.3,        
                              "market_price": 0.5,                  
                              "yield_confirmed_date":0,
                              "yield_percent":15,
                              "yield_from_date":"2022-05-25",
                              "yield_date":"2023-02-25",
                              "data_live":1,
                              },*/

        crypto_user_data: null,
        /*crypto_user_data: {"email":"tomasz.andel@gmail.com",
                                                 "uid":"a6yw5go4wi",
                                                 "tokens": 2000,
                                                 "tokens_vested": 1700,
                                                 "transfering": 0, // specify if some token transfer is submitted for execution, block all until its not cleared
                                                 "in_transfer": 100, // number of tokens that are in transfer now, available = tokens - tokens_vested - in_transfer
                                                 "dividend_current":0,
                                                 "dividend_current_per":0,
                                                 "dividend_potential":0,
                                                 "dividend_potential_per":0,
                                                },*/
        metamask: null,

         /*
                We can store some basic info inside but no offers not bids
                metamask: { 
                  ok: 1,
                  new: 1,
                  exist: 0,
                },
        */


        metamaskBalance: 0,
        metamaskObj: null,
        wallet_metamask: false,
        wallet_metamask_loaded: false, // old wallet
        lifeTokenAddress: '', //
        transferIntents: null,
        lifeabi: [],
        masteraddress: '',
        decimals: 0,
        metamaskwallets: [],
        accounthistorywallets: [],
        transactions: [],
        nftOffers: [],

      // End Crypto
    }
  },
  mutations: {
    // Player
    SET_PLAYLIST_CREATION(state, value) {
      state.playlistcreation = value;
    },
    SET_IS_PLAYING(state, value) {
      state.isPlaying = value;
    },
    SET_IS_MUSIC_LOADING(state, value) {
      state.ismusicloading = value;
    },
    SET_CURRENT_TRACK_INFO(state, value) {
      state.currentTrackInfo = value;
    },
    SET_USE_HLS(state, value) {
      state.usehls = value;
    },
    SET_HLS_READY(state, value) {
      state.hlsready = value;
    },
    // End Player
    SET_DISABLED_2FA (state) {
      state.user['2fa'] = 0;
      this.commit('SET_USER_DATA_LS', state.user);
    },
    SET_ENABLED_2FA (state) {
      state.user['2fa'] = 1;
      this.commit('SET_USER_DATA_LS', state.user);
    },
      // TODO remove this
    SET_COOKIES (state, userData) {
     
      EventService.setUserCookies(userData)
        .then(() => {
          // All ok
        }).catch((error) => {
          // Network error logout to clear cookies and local storage - keep consistency (state with cookies)
          this.commit('LOGOUT');
        });
    },
    SET_2FA_NEED (state, userData) {
      state.auth2fa = true;
      state.preLoginData = userData;
    },
    SET_2FA_NOT_NEED (state) {
      state.auth2fa = false;
      state.preLoginData = null;
    },
    SET_USER_DATA_LS (state, userData) {
      state.user = userData;
      localStorage.setItem('user-muzible', JSON.stringify(userData))
    },
    LOGOUT (state) {

      EventService.deleteUserCookies({cookies: 'remove'})
      .then(() => {
        localStorage.removeItem('user-muzible');
        state.p2puser = null;
        state.p2puseroffers = null;
        state.user = null;
        state.auth2fa = false;
        state.preLoginData = null;
        state.decimals = 0;
        state.transferIntents = null;
        state.crypto_dashboard_data = null;
        state.crypto_user_data = null;
        state.metamask = null;
        state.metamaskBalance = 0;
        state.metamaskObj = null;
        state.wallet_metamask = false;
        state.wallet_metamask_loaded = false;
        state.lifeTokenAddress = '';
        state.lifeabi = [];
        state.masteraddress = '';
        location.href="https://login.muzible.com/"  
      }).catch((error) => {
        localStorage.removeItem('user-muzible');
        state.p2puser = null;
        state.p2puseroffers = null;
        state.user = null;
        state.auth2fa = false;
        state.preLoginData = null;
        state.decimals = 0;
        state.transferIntents = null;
        state.crypto_dashboard_data = null;
        state.crypto_user_data = null;
        state.metamask = null;
        state.metamaskBalance = 0;
        state.metamaskObj = null;
        state.wallet_metamask = false;
        state.wallet_metamask_loaded = false;
        state.lifeTokenAddress = '';
        state.lifeabi = [];
        state.masteraddress = '';
        location.href="https://login.muzible.com/"    
      });
    
    },
    SET_MUZE(state, param) {
      state.muze = param
    },
    SET_NFT(state, param) {
      state.nft = param
    },
    SET_SHOP(state, param) {
      state.shop = param
    },
    SET_TICKETS(state, param) {
      state.tickets = param
    },
    SET_USER_SUBSCRIPTIONS(state, data) {
      state.subscriptions_nft = data.subscriptions
    },
    SET_REFERAL_SOURCE (state, source) {
      state.referal_source = source
    },
    SET_REFERAL_MEDIUM (state, medium) {
      state.referal_medium = medium
    },
    SET_REFERAL_CAMPAIGN (state, campaign) {
      state.referal_campaign = campaign
    },
    SET_P2P_USER(state, data) {
      state.p2puser = data
    },
    SET_P2P_USER_OFFERS(state, data) {
      state.p2puseroffers = data
    },
    SET_USER_PLAYLISTS(state, data) {
      state.userplaylists = data.playlists
    },
    SET_USER_EXT_PLAYLISTS(state, data) {
      state.userextplaylists = data.playlists
    },
    SET_USER_FAV_SONGS(state, data) {
      state.userfavsongs = data.songs
    },
    SET_USER_FAV_SONGS_SPLICE(state, data) {
      state.userfavsongs.splice(data, 1);
    },
    SET_USER_CURRENT_SONGS(state, data) {
      if (data.songs.length > 0) {
        state.usercurrentsongs = data.songs
      } else {
        state.usercurrentsongs = state.tracks_1
      }
    },
    SET_USER_SEARCH_RESULTS(state, data) {
      state.usersearchresults = data.res
    },
    SET_USER_SUB_CREATORS(state, data) {
      state.usersubcreators = data.creators
    },
    SET_USER_TICKETS(state, data) {
      state.tickets_nft = data.tickets
    },
    SET_USER_COLLECTIONS(state, data) {
      state.collections_nft = data.collections
    },
    SET_USER_COLLECTIONS_MUSIC(state, data) {
      state.collections_music = data.collections
    },
    SET_PLAYLIST_CREATION_DATA(state, data) {
      state.userplaylists.unshift(data.playlist);
      state.userplaylists[0].id = data.id;
      state.userplaylists[0].timestamp = data.timestamp;
    },
    SET_USER_FAV_SONGS_PUSH(state, data) {
      state.userfavsongs.push(data);
    },
    SET_USER_CURRENT_SONGS_POP(state) {
      state.usercurrentsongs.pop();
    },
    SET_USER_CURRENT_SONGS_PUSH(state, data) {
      state.usercurrentsongs.push(data);
    },
    SET_USER_CURRENT_SONGS_UNSHIFT(state, data) {
      state.usercurrentsongs.unshift(data);
    },
    SET_USER_CURRENT_SONGS_SPLICE(state, data) {
      state.usercurrentsongs.splice(data, 1);
    },
    REMOVE_TRACK_FROM_PLAYLIST_INTERNAL(state, data) {
      const playlistIndex = state.userplaylists.findIndex(pl => pl.id === data.playlistId);
      const pl = state.userplaylists[playlistIndex];
      const newtracks = pl.tracks.filter(id => id !== data.trackId);
      state.userplaylists[playlistIndex].tracks = newtracks
    },
    ADD_TRACK_TO_PLAYLIST_INTERNAL(state, data) {
      const playlistIndex = state.userplaylists.findIndex(pl => pl.id === data.playlistId);
      state.userplaylists[playlistIndex].tracks.push(data.trackId)
    },
    SET_CURRENT_TRACK_INDEX(state, index) {
      state.currentTrackIndex = index;
    },
    // Crypto
    SET_DASHBOARD_DATA (state, dataDashboard) {
      state.crypto_dashboard_data = dataDashboard
    },
    SET_USER_CRYPTO_DATA( state, userCrypto) {
      state.crypto_user_data = userCrypto
    },
    ACTIVATE_METAMASK_WALLET (state){
      state.wallet_metamask = true;
    },
    DEACTIVATE_METAMASK_WALLET (state){
      state.wallet_metamask = false;
    },
    SET_METAMASK_WALLET (state, data) {
      state.metamaskObj = data;
      if (data === null){
        state.wallet_metamask_loaded = false;
      }
      else {
        state.wallet_metamask_loaded = true;
      }
    },
    SET_METAMASK_BALANCE( state, balance) {
      if (state.metamask) {
        state.metamaskBalance = balance;
      }
    },
    SET_METAMASK_WALLETOBJ( state, data) {
      state.metamask = data;
    },
  
    SET_LIFE_TOKEN_ADDRESS( state, data) {
      state.lifeTokenAddress = data.address
    },
    SET_LIFE_MASTER_ADDRESS( state, data) {
      state.masteraddress = data.address
    },
    SET_LIFE_TOKEN_ABI( state, data) {
      state.lifeabi = data.abi
    },
    SET_DECIMALS( state, data) {
      state.decimals = data.decimals
    },
    SET_TRANSFER_INTENTS( state, data) {
      state.transferIntents = data.intents
    },
    SET_USER_DNA_KITS( state, data) {
      state.dnaKits = data.kits
    },
    SET_USER_METAMASK_WALLETS( state, data) {
      state.metamaskwallets = data.addresses
    },
    SET_ACCOUNT_HISTORY_WALLETS( state, data) {
      state.accounthistorywallets = data.actions
    },
    SET_TRANSACTIONS( state, data) {
      state.transactions = data.transactions
    },
    SET_NFT_OFFERS( state, data) {
      state.nftOffers = data.offers
    },
    // End Crypto

    // Tickets
    UPDATE_TICKET_STATUS(state, { ticketId, status }) {
      const ticket = state.tickets_nft.find(t => t.id === ticketId)
      if (ticket) {
        ticket.status = status
        ticket.updated_at = new Date().toISOString()
      }
    },
    USE_TICKET(state, { ticketId, validatedBy }) {
      const ticket = state.tickets_nft.find(t => t.id === ticketId)
      if (ticket) {
        ticket.is_used = 1
        ticket.used_date = new Date().toISOString()
        ticket.used_by = validatedBy
        ticket.validation_count++
        ticket.validation_history.push({
          validated_date: new Date().toISOString(),
          validated_by: validatedBy,
          validated_location: "Gate A",
          validation_type: "entry"
        })
      }
    },
    USE_PERK(state, { ticketId, perkId }) {
      const ticket = state.tickets_nft.find(t => t.id === ticketId)
      if (ticket) {
        const perk = ticket.perks.find(p => p.perk_id === perkId)
        if (perk) {
          perk.perk_used = 1
          perk.perk_used_date = new Date().toISOString()
          if (perk.perk_quantity) {
            perk.perk_quantity_used++
            if (perk.perk_quantity_used >= perk.perk_quantity) {
              perk.perk_used = 1
            }
          }
        }
      }
    },

  },
  actions: {
    // Player
    setPlaylistCreation({ commit }, value) {
      commit('SET_PLAYLIST_CREATION', value);
    },
    setIsPlaying({ commit }, value) {
      commit('SET_IS_PLAYING', value);
    },
    setIsMusicLoading({ commit }, value) {
      commit('SET_IS_MUSIC_LOADING', value);
    },
    setCurrentTrackInfo({ commit }, value) {
      commit('SET_CURRENT_TRACK_INFO', value);
    },
    setUseHls({ commit }, value) {
      commit('SET_USE_HLS', value);
    },
    setHlsReady({ commit }, value) {
      commit('SET_HLS_READY', value);
    },

    setUserPlaylists({ commit }, data) {
      commit('SET_USER_PLAYLISTS', data);
    },
    setPlaylistCreationData({ commit }, data) {
      commit('SET_PLAYLIST_CREATION_DATA', data);
    },
    setUserExtPlaylists({ commit }, data) {
      commit('SET_USER_EXT_PLAYLISTS', data);
    },
    setUserFavSongs({ commit }, data) {
      commit('SET_USER_FAV_SONGS', data);
    },
    setUserFavSongsSplice({ commit }, data) {
      commit('SET_USER_FAV_SONGS_SPLICE', data);
    },
    setUserTracks({ commit }, data) {
      commit('SET_USER_CURRENT_SONGS', data);
    },
    setUserTracksPush({ commit }, data) {
      commit('SET_USER_CURRENT_SONGS_PUSH', data);
    },
    setUserTracksUnshift({ commit }, data) {
      commit('SET_USER_CURRENT_SONGS_UNSHIFT', data);
    },
    setUserTracksSplice({ commit }, data) {
      commit('SET_USER_CURRENT_SONGS_SPLICE', data);
    },
    setUserTracksPop({ commit }) {
      commit('SET_USER_CURRENT_SONGS_POP');
    },
    setUserSubscribedCreators({ commit }, data) {
      commit('SET_USER_SUB_CREATORS', data);
    },
    setUserFavSongsPush({ commit }, data) {
      commit('SET_USER_FAV_SONGS_PUSH', data);
    },
    removeTrackFromPlaylistInternal({ commit }, data) {
      commit('REMOVE_TRACK_FROM_PLAYLIST_INTERNAL', data);
    },
    addTrackToPlaylistInternal({ commit }, data) {
      commit('ADD_TRACK_TO_PLAYLIST_INTERNAL', data);
    },
    // Player End
    setMuze: ({commit}, param) => {
      commit('SET_MUZE', param)
    },
    setNFT: ({commit}, param) => {
      commit('SET_NFT', param)
    },
    setTickets: ({commit}, param) => {
      commit('SET_TICKETS', param)
    },
    setShop: ({commit}, param) => {
      commit('SET_SHOP', param)
    },
    reset2fa: ({ commit} ) => {
      commit('SET_2FA_NOT_NEED')
    },
    get2faQR: ({ commit }, credentials) => {
      /*var data = {
        "qr": "https://www.google.com",
      };
      const promise = Promise.resolve(data);
      return promise;*/

      return EventService.get2faQR(credentials)
    },
    enableauth2fa: ({ commit }, credentials) => {

      //commit('SET_ENABLED_2FA');
        //const error = new Error('Authentication failed');
        //const promise = Promise.reject(error);
        //return promise;
        //const error = new Error('Bad Request');
        //error.response = { status: 400 };
        //return Promise.reject(error);
      //const promise = Promise.resolve();
      //return promise;

        return EventService.enableauth2fa(credentials)
            .then(({ data }) => {
                commit('SET_ENABLED_2FA');
            })
    },
    disableauth2fa: ({ commit }, credentials) => {

      //commit('SET_DISABLED_2FA');

        //const error = new Error('Authentication failed');
        //const promise = Promise.reject(error);
        //return promise;
      //  const error = new Error('Bad Request');
      //  error.response = { status: 400 };
      //  return Promise.reject(error);
      //const promise = Promise.resolve();
      //return promise;

        return EventService.disableauth2fa(credentials)
            .then(({ data }) => {
                commit('SET_DISABLED_2FA');
            })

    },
    auth2fa: ({ commit }, credentials) => {
      /*
        var data = {
          "token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InRvbWFzei5hbmRlbEBnbWFpbC5jb20iLCJpYXQiOjE3MTMxMTUwNjAsImV4cCI6MTcxMzIwMTQ2MH0.csGNI5gXxjGZj9wA2aFEszTdapTTUtvlGC_XPy-icBw",
          "email":"tomasz.andel@gmail.com",
          "uid":"160nahwyn4",
          "creator": "tomand",
          "level":0, // 0 - darmowe, 1- platne, 2- premium,
          "2fa":1,
          "kyc": 0,
          "kyc_corp": 0,
          "kyc_awers": "",
          "kyc_awers_verified": 0,
          "kyc_rewers": "",
          "kyc_rewers_verified": 0,
          "kyc_address": "",
          "kyc_address_verified": 0,
          "kyc_company": "",
          "kyc_company_verified": 0,
          "creator_verified": 0,
          "creator_verified_paid": 0,
          "creator_confirmed": 0,
          "creator_verification_inprogress": 0,
          "creator_doc": "",
          "creator_doc_verified": 0,
          "creator_artists": [{"NRA-LAB": 'ARTISTID'}, {"NRA-LAB2": 'ARTISTID2'}],
          "creator_linked_artists_pay": [{"NRA-LAB1": 'ARTISTID'}, {"NRA-LAB21": 'ARTISTID2'}], // artyscie przeniesieni z B2B do wlasnych artystow zarzadzanych. mozna wtedy go subskrybowac, muzyka przenoszona jest do artistid/tracks
          // jewsli artysta jest subscribable to kazdy nowy album/utwor trafia tez do artistid/tracks
          "creator_linked_artists_view": [{"NRA-LAB2": 'ARTISTID'}, {"NRA-LAB22": 'ARTISTID2'}],
          "event_organizer": "", // jesli jest organizatorem eventow to jego unikatowa nazwa
          "membersince":"2024-03-31 17:25:22",
          "name":"asd",
          "surname":"asd",
          "address":"",
          "address2":"",
          "postal":"sad",
          "tel":"",
          "active":1,
          "disabled_since":"",
          "city":"",
          "country":"",
          "company":"asd",
          "companyvat":"asd",
          "company_address":"asd",
          "company_postal":"asd",
          "company_city":"Wro",
          "company_country": "Poland",
          "refsource":"na",
          "refmedium":"na",
          "refcampaign":"na",
          "locale":"en",
          "fb_reg":0,
          "goo_reg":0,
          "tw_reg":0,
          "subscribe":0,
          "customer_id":"",
          "sub_id":""
        }; 
        */

        //commit('SET_2FA_NOT_NEED')
        //commit('SET_USER_DATA_LS', data)
        //const error = new Error('Authentication failed');
        //const promise = Promise.reject(error);
        //return promise;
        //const error = new Error('Bad Request');
        //error.response = { status: 400 };
        //return Promise.reject(error);

        //const promise = Promise.resolve(data);
        //return promise;

        return EventService.auth2fa(credentials)
            .then(({ data }) => {
                commit('SET_2FA_NOT_NEED')
                commit('SET_USER_DATA_LS', data)
                commit('SET_COOKIES', data);
            })

    },
    login: ({ commit }, credentials) => {
        /*  
        var data = {
            "token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InRvbWFzei5hbmRlbEBnbWFpbC5jb20iLCJpYXQiOjE3MTMxMTUwNjAsImV4cCI6MTcxMzIwMTQ2MH0.csGNI5gXxjGZj9wA2aFEszTdapTTUtvlGC_XPy-icBw",
            "email":"tomasz.andel@gmail.com",
            "uid":"160nahwyn4",
            "creator": "tomand",
            "level":0, // 0 - darmowe, 1- platne, 2- premium, 
            "2fa":1,
            "kyc": 0,
            "kyc_corp": 0,
            "kyc_awers": "",

            "verse_username": "",
            "verse_displayname": "",
            "verse_avatar": "",
            "verse_background": "",
            "verse_bio": "",
            "verse_location": "",
            "verse_website": "",
            "verse_twitter": "",
            "verse_facebook": "",
            "verse_instagram": "",
            "verse_youtube": "",
            "verse_tiktok": "",
            "verse_twitch": "",

            "kyc_awers_verified": 0,
            "kyc_rewers": "",
            "kyc_rewers_verified": 0,
            "kyc_address": "",
            "kyc_address_verified": 0,
            "kyc_company": "",
            "kyc_company_verified": 0,
            "creator_verified":0,
            "creator_verified_paid": 0,
            "creator_confirmed": 0,
            "creator_verification_inprogress": 0,
            "creator_doc": "",
            "creator_doc_verified": 0,
            "creator_artists": [{"NRA-LAB": 'ARTISTID'}, {"NRA-LAB2": 'ARTISTID2'}],
            "creator_linked_artists_pay": [{"NRA-LAB1": 'ARTISTID'}, {"NRA-LAB21": 'ARTISTID2'}], // artyscie przeniesieni z B2B do wlasnych artystow zarzadzanych. mozna wtedy go subskrybowac, muzyka przenoszona jest do artistid/tracks
            // jewsli artysta jest subscribable to kazdy nowy album/utwor trafia tez do artistid/tracks
            "creator_linked_artists_view": [{"NRA-LAB2": 'ARTISTID'}, {"NRA-LAB22": 'ARTISTID2'}],
            "event_organizer": "", // jesli jest organizatorem eventow to jego unikatowa nazwa
            "membersince":"2024-03-31 17:25:22",
            "name":"asd",
            "surname":"asd",
            "address":"",
            "address2":"",
            "postal":"sad",
            "tel":"",
            "active":1,
            "disabled_since":"",
            "city":"dd",
            "country":"",
            "company":"",
            "companyvat":"",
            "company_address":"",
            "company_postal":"",
            "company_city":"",
            "company_country": "Poland",
            "refsource":"na",
            "refmedium":"na",
            "refcampaign":"na",
            "locale":"en",
            "fb_reg":0,
            "goo_reg":0,
            "tw_reg":0,
            "subscribe":0,
            "customer_id":"",
            "sub_id":""
        };

        if (data['2fa'] !== 1) {
          commit('SET_2FA_NOT_NEED')
          commit('SET_USER_DATA_LS', data)
        } else {
          commit('SET_2FA_NEED', data)
        }
        const promise = Promise.resolve(data);
        return promise;
        */

      return EventService.postLogin(credentials)
            .then(({ data }) => {
              if (data['2fa'] !== 1) {
                commit('SET_2FA_NOT_NEED')
                commit('SET_USER_DATA_LS', data)
                commit('SET_COOKIES', data);
              } else {
                commit('SET_2FA_NEED', data)
              }
            })
     },
     forgotpass: ({ commit }, email) => {

       /* var data = {
          "ok": 1
        };
        const promise = Promise.resolve(data);
        return promise;*/

        return EventService.forgotPass(email)
     },
     forgotpasstoken: ({ commit }, token) => {
        return EventService.forgotPassToken(token)
     },
     resetpass: ({ commit }, info) => {
      
        /*var data = {
          "ok": 1
        };
        const promise = Promise.resolve(data);
        return promise;*/
      
        return EventService.resetPass(info)
     },
     logout: ({commit}) => {
      commit('LOGOUT')
     },
     checkEmail: ({ commit }, email) => {

      /*var data = {
        "ok": 1
      };
      const promise = Promise.resolve(data);
      return promise;*/

      return EventService.checkEmail(email)
     },
     checkUsername: ({ commit }, username) => {
      
      /*var data = {
        "ok": 1
      };
      const error = new Error('Bad Request');
      error.response = { status: 400 };
      return Promise.reject(error);*/

      //const promise = Promise.resolve(data);
      //return promise;

      return EventService.checkUsername(username)
     },
     storeAddress: ({ commit }, address) => {
        
       /* var data = {
          "ok": 1
        };
        const promise = Promise.resolve(data);
        return promise;*/
  
        return EventService.storeAddress(address).then(({ data }) => {
          commit('SET_USER_DATA_LS', data)
        })
     },
     removeAddress: ({ commit }, address) => {
          
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
    
          return EventService.removeAddress(address).then(({ data }) => {
            commit('SET_USER_DATA_LS', data)
          })
     },
     storeCompany: ({ commit }, company) => {
              
             /* var data = {
                "ok": 1
              };
              const promise = Promise.resolve(data);
              return promise;*/
        
            return EventService.storeCompany(company).then(({ data }) => {
                commit('SET_USER_DATA_LS', data)
            })
     },
     removeCompany: ({ commit }, company) => {
                    
                   /* var data = {
                      "ok": 1
                    };
                    const promise = Promise.resolve(data);
                    return promise;*/
              
                  return EventService.removeCompany(company).then(({ data }) => {
                    commit('SET_USER_DATA_LS', data)
                })
     },
     disableAccount: ({ commit }, credentials) => {
                        
                       /* var data = {
                          "ok": 1
                        };
                        const promise = Promise.resolve(data);
                        return promise;*/
                  
                  return EventService.disableAccount(credentials).then(({ data }) => {
                    commit('SET_USER_DATA_LS', data)
                  }) 
     },
     enableAccount: ({ commit }, credentials) => {
                            
                          /*  var data = {
                              "ok": 1
                            };
                            const promise = Promise.resolve(data);
                            return promise;*/
                      
                  return EventService.enableAccount(credentials).then(({ data }) => {
                    commit('SET_USER_DATA_LS', data)
                  })  
     },
     changeusername: ({ commit }, username) => {         
                               /* var data = {
                                  "ok": 1
                                };
                                const promise = Promise.resolve(data);
                                return promise;*/
                          
                  return EventService.changeUsername(username).then(({ data }) => {
                    commit('SET_USER_DATA_LS', data)
                  })
     },
     changeEmail: ({ commit }, email) => {
                                  
                                 /* var data = {
                                    "ok": 1
                                  };
                                  const promise = Promise.resolve(data);
                                  return promise;*/
                            
                return EventService.changeEmail(email).then(({ data }) => {
                    commit('SET_USER_DATA_LS', data)
                 })
     },
     checkJWTValid: ({ commit }, credentials) => {

       /* var data = {
            "jwtinvalid": 0
        };
        if (data.jwtinvalid === 1) {
          commit('LOGOUT')
          return;
        }
        const promise = Promise.resolve(data);
        return promise;*/

      return EventService.checkJWTValid(credentials);
     },
     register: ({ commit }, credentials) => {

      /*
      var data = {
        "token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InRvbWFzei5hbmRlbEBnbWFpbC5jb20iLCJpYXQiOjE3MTMxMTUwNjAsImV4cCI6MTcxMzIwMTQ2MH0.csGNI5gXxjGZj9wA2aFEszTdapTTUtvlGC_XPy-icBw",
        "email":"tomasz.andel@gmail.com",
        "uid":"160nahwyn4",
        "creator": "tomand",
        "level":1, // 0 - darmowe, 1- platne, 2- premium,
        "membersince":"2024-03-31 17:25:22",
        "name":"",
        "surname":"",
        "address":"",
        "address2":"",
        "postal":"",
        "tel":"",
        "active":1,
        "disabled_since":"",
        "city":"",
        "country":"",
        "company":"",
        "companyvat":"",
        "company_address":"",
        "company_postal":"",
        "company_city":"",
        "company_country": "Poland",
        "refsource":"na",
        "refmedium":"na",
        "refcampaign":"na",
        "locale":"en",
        "fb_reg":0,
        "goo_reg":0,
        "tw_reg":0,
        "subscribe":0,
        "customer_id":"",
        "sub_id":"",
        "kyc": 0,
        "kyc_corp": 0,
        "kyc_awers": "",
        "kyc_awers_verified": 0,
        "kyc_rewers": "",
        "kyc_rewers_verified": 0,
        "kyc_address": "",
        "kyc_address_verified": 0,
        "kyc_company": "",
        "kyc_company_verified": 0,
        "creator_verified":0,
        "creator_verified_paid": 0,
        "creator_confirmed": 0,
        "creator_verification_inprogress": 0,
        "creator_doc": "",
        "creator_doc_verified": 0,
        "creator_artists": [{"NRA-LAB": 'ARTISTID'}, {"NRA-LAB2": 'ARTISTID2'}],
        "creator_linked_artists_pay": [{"NRA-LAB1": 'ARTISTID'}, {"NRA-LAB21": 'ARTISTID2'}], // artyscie przeniesieni z B2B do wlasnych artystow zarzadzanych. mozna wtedy go subskrybowac, muzyka przenoszona jest do artistid/tracks
        // jewsli artysta jest subscribable to kazdy nowy album/utwor trafia tez do artistid/tracks
        "creator_linked_artists_view": [{"NRA-LAB2": 'ARTISTID'}, {"NRA-LAB22": 'ARTISTID2'}],
        "event_organizer": "", // jesli jest organizatorem eventow to jego unikatowa nazwa
      };
      commit('SET_USER_DATA_LS', data)
      const promise = Promise.resolve(data);
      return promise;
      */

      return EventService.postCredentials(credentials)
            .then(({ data }) => {
              commit('SET_USER_DATA_LS', data)
              commit('SET_COOKIES', data);
            })
     },
     consent: ({ commit }, credentials) => {
      /*
      var data = {
        "token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InRvbWFzei5hbmRlbEBnbWFpbC5jb20iLCJpYXQiOjE3MTMxMTUwNjAsImV4cCI6MTcxMzIwMTQ2MH0.csGNI5gXxjGZj9wA2aFEszTdapTTUtvlGC_XPy-icBw",
        "email":"tomasz.andel@gmail.com",
        "uid":"160nahwyn4",
        "creator": "tomand",
        "level":1, // 0 - darmowe, 1- platne, 2- premium,
        "membersince":"2024-03-31 17:25:22",
        "name":"",
        "kyc": 0,
        "kyc_corp": 0,
        "kyc_awers": "",
        "kyc_awers_verified": 0,
        "kyc_rewers": "",
        "kyc_rewers_verified": 0,
        "kyc_address": "",
        "kyc_address_verified": 0,
        "kyc_company": "",
        "kyc_company_verified": 0,
        "creator_verified":0,
        "creator_verified_paid": 0,
        "creator_confirmed": 0,
        "creator_verification_inprogress": 0,
        "creator_doc": "",
        "creator_doc_verified": 0,
        "creator_artists": [{"NRA-LAB": 'ARTISTID'}, {"NRA-LAB2": 'ARTISTID2'}],
        "creator_linked_artists_pay": [{"NRA-LAB1": 'ARTISTID'}, {"NRA-LAB21": 'ARTISTID2'}], // artyscie przeniesieni z B2B do wlasnych artystow zarzadzanych. mozna wtedy go subskrybowac, muzyka przenoszona jest do artistid/tracks
        // jewsli artysta jest subscribable to kazdy nowy album/utwor trafia tez do artistid/tracks
        "creator_linked_artists_view": [{"NRA-LAB2": 'ARTISTID'}, {"NRA-LAB22": 'ARTISTID2'}],
        "event_organizer": "", // jesli jest organizatorem eventow to jego unikatowa nazwa
        "surname":"",
        "address":"",
        "address2":"",
        "postal":"",
        "tel":"",
        "active":1,
        "disabled_since":"",
        "city":"",
        "country":"",
        "company":"",
        "companyvat":"",
        "company_address":"",
        "company_postal":"",
        "company_city":"",
        "company_country": "Poland",
        "refsource":"na",
        "refmedium":"na",
        "refcampaign":"na",
        "locale":"en",
        "fb_reg":0,
        "goo_reg":0,
        "tw_reg":0,
        "subscribe":0,
        "customer_id":"",
        "sub_id":""
      };
      commit('SET_USER_DATA_LS', data)
      const promise = Promise.resolve(data);
      return promise;*/

      return EventService.consent(credentials)
            .then(({ data }) => {
              commit('SET_USER_DATA_LS', data)
            })
     },
      setReferalSource: ({commit}, source) => {
            commit('SET_REFERAL_SOURCE', source)
      },
      setReferalMedium: ({commit}, medium) => {
            commit('SET_REFERAL_MEDIUM', medium)
      },
      setReferalCampaign: ({commit}, campaign) => {
            commit('SET_REFERAL_CAMPAIGN', campaign)
      },
       getP2PUser: ({ commit }, credentials) => {
        var data = {
          buy_requests: 0,
          sell_requests: 0,   
          total_buy_tokens: 0,
          total_sell_tokens: 0,
          total_market_sell: 0,
          total_market_buy: 0,
          total_buy: '0 USD',  
          total_sell: '0 USD', 
        };
        commit('SET_P2P_USER', data);
        const promise = Promise.resolve(data);
        return promise;
        
        /*return EventService.getP2PUser(credentials)
              .then(({ data }) => {
                commit('SET_P2P_USER', data)
              })*/
       },

       getP2PUserOffers: ({ commit }, credentials) => {
        var data = {
          total: 0,
          buy_offers: 0,
          sell_offers: 0,
          buy: [
            
          ],
          sell: [

          ]
        };
        commit('SET_P2P_USER_OFFERS', data);
        const promise = Promise.resolve(data);
        return promise;
        
        /*return EventService.getP2PUserOffers(credentials)
              .then(({ data }) => {
                commit('SET_P2P_USER_OFFERS', data)
              })*/
       },

       getUserPlaylists: ({ commit }, credentials) => {
        // pobierajac ID w bazie w src wpisujemy albo dobry link albo tylko 10s utworu (jesli nie jestesmy uprawnieni do odtworzenia)
        // nie wysylamy owner adresu dla playlist zwrotnie.
        // jesli owner jest nie ustawiony to jesli chcemy zrobic liste publiczna to musimy stworzyc uniiaktowy creator name
        /*
          playlists: [
            {'name': 'playlist2', 'public': 0,'saved': 0, 'liked': 0, 'creator': 'Name', 'timestamp':'22.11.2024' ,'id': 'IDPLAYLIST2', 'src': require('@/assets/images/muzible_11_4.webp'),'tracks':['IDTRACK1','IDTRACK2']},
          ]
        */
        /*var data = {
         
          //playlists:[]
          playlists: [
            {'name': 'Geo Music', 'public': 0,'saved': 0, 'liked': 0, 'creator': 'Muzible', 'timestamp':'2024-11-12 12:12:12' ,'id': 'DEFAULTPLAYLISTGEO', 'src': 'https://cdn-img.muzible.com/tracks/default/DEFAULT004_200x200.avif','tracks':['DEFAULT004','DEFAULT005']},
          ]
        };
        commit('SET_USER_PLAYLISTS', data)
        const promise = Promise.resolve(data);
        return promise;*/
        
        return EventService.getUserPlaylists(credentials)
              .then(({ data }) => {
                commit('SET_USER_PLAYLISTS', data)
              })
       },
       getQuerySearch: ({ commit }, credentials) => {
        /*var data = {
          res: JSON.parse(JSON.stringify(search_data)),
        };
        commit('SET_USER_SEARCH_RESULTS', data)
        const promise = Promise.resolve(data);
        return promise;*/
        
        // get user external playlists and query internally to get info about them
        return EventService.getQuerySearch(credentials)
              .then(({ data }) => {
                commit('SET_USER_SEARCH_RESULTS', data)
              })
       },
       getUserExtPlaylists: ({ commit }, credentials) => {
        // chyba tracks nie beda pobierane odrazu bo tych playlist moze bcy wiecej max 150.
        // pobierajac ID w bazie w src wpisujemy albo dobry link albo tylko 10s utworu (jesli nie jestesmy uprawnieni do odtworzenia)
        // pobierajac ID playlist moze sie okazac ze ich juz nie ma zostaly usuniete badz przeniesione do prywtnych -> wtedy automatycznie je wywalamy z userExtPlaylist
        // playlisty maja tez owner name ale nie dostajemy go zwrotnie, dostajemy jedynie unikatowy creator name ktory kazdy user robiacy publiczna playliste musi miec ustawiony
        /*
          playlists: [
            {'name': 'playlist1', 'public': 1,'saved': 0,'liked': 0,'creator': 'Name','timestamp':'22.11.2024' , 'id': 'IDPLAYLIST1', 'src': require('@/assets/images/muzible_11_4.webp'),'tracks':['IDTRACK1','IDTRACK2']},
          ]
        */
        /*var data = {
          playlists: []
        };
        commit('SET_USER_EXT_PLAYLISTS', data)
        const promise = Promise.resolve(data);
        return promise;*/
        
        // get user external playlists and query internally to get info about them
        return EventService.getUserExtPlaylists(credentials)
              .then(({ data }) => {
                commit('SET_USER_EXT_PLAYLISTS', data)
              })
       },
       getUserLocationForTrack: ({ commit }, credentials) => {
        /*var data = {
          "inside": 0,
          "src": '',
          "hlssrc": 'https://cdn.s0.muzible.com/DEFAULT004/DEFAULT004.mpd',
        };
        const promise = Promise.resolve(data);
        return promise;*/

        return EventService.getUserLocationForTrack(credentials)
       },
       getUserFavSongs: ({ commit }, credentials) => {
        /*var data = {
          // okrojone informacje wystarczajace do odtworzenia - max 100 utworow
          // pobierajac ID w bazie w src wpisujemy albo dobry link albo tylko 5s utworu (jesli nie jestesmy uprawnieni do odtworzenia)
          songs: []
        };
        commit('SET_USER_FAV_SONGS', data)
        const promise = Promise.resolve(data);
        return promise;*/
        
        // get user external playlists and query internally to get info about them
        return EventService.getUserFavSongs(credentials)
              .then(({ data }) => {
                commit('SET_USER_FAV_SONGS', data)
              })
       },
       getUserCurrentSongs: ({ commit }, credentials) => {
        /*var data = {
          // okrojone informacje wystarczajace do odtworzenia - max 150 utworow (wielkosc max playlisty)
          songs: JSON.parse(JSON.stringify(songs_data))
        };
        commit('SET_USER_CURRENT_SONGS', data)
        const promise = Promise.resolve(data);
        return promise;*/
        
        // get user external playlists and query internally to get info about them
        return EventService.getUserCurrentSongs(credentials)
              .then(({ data }) => {
                commit('SET_USER_CURRENT_SONGS', data)
              })
       },
       addUserFavSong: ({ commit }, credentials) => {
        /*var data = {
          "ok": 1
        };
        const promise = Promise.resolve(data);
        return promise;*/
        
        return EventService.addUserFavSong(credentials)
       },
        removeUserFavSong: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.removeUserFavSong(credentials)
        },
        removeTrackFromPlaylist: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.removeTrackFromPlaylist(credentials)
        },
        addTrackToPlaylist: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.addTrackToPlaylist(credentials)
        },
        createNewPlaylist: ({ commit }, credentials) => {
          /*const randomString = Math.random().toString(36).substring(8, 15);
            var data = {
            "id": randomString,            
            "timestamp": "2025-01-31 17:25:22",
            };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.createNewPlaylist(credentials)
        },
        deletePlaylist: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.deletePlaylist(credentials)
        },
        generateGoogleWalletPass: async ({ commit }, credentials) => {
          /*var data = {
            "ok": 1,
            "link": "https://pay.google.com/gp/v/save/xyz123abc456def789ghi0jkl"
          };
          const promise = Promise.resolve(data);
          return promise;*/
            try {
              const response = await EventService.generateGoogleWalletPass(credentials);
              
              if (response && response.data) {
                return response.data;
              }
              
              return null;
            } catch (error) {
              console.error('Store generateGoogleWalletPass error:', error);
              throw error;
            }
        },
         generateAppleWalletPass: async ({ commit }, credentials) => {
          /*var data = {
            "ok": 1,
            "link": "https://example.com/path/to/apple_wallet_pass.pkpass"
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
                    
            try {
              const response = await EventService.generateAppleWalletPass(credentials);
              
              if (response && response.data) {
                return response.data;
              }
              
              return null;
            } catch (error) {
              console.error('Store generateAppleWalletPass error:', error);
              throw error;
            }
        },
        shareTicketToVerse: async ({ commit }, credentials) => {
          /*var data = {
            "ok": 1,
            "post_url": "https://verse.muzible.com/userid/post?postid=idnumber"
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
            try {
              const response = await EventService.shareTicketToVerse(credentials);
              
              if (response && response.data) {
                return response.data;
              }
              
              return null;
            } catch (error) {
              console.error('Store shareTicketToVerse error:', error);
              throw error;
            }
        },
        requestTicketRefund: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.requestTicketRefund(credentials)
        },
        requestTicketRefundPolicy: async ({ commit }, credentials) => {
            try {
              const response = await EventService.requestTicketRefundPolicy(credentials);
              
              if (response && response.data) {
                return response.data;
              }
              
              return null;
            } catch (error) {
              console.error('Store requestTicketRefundPolicy error:', error);
              throw error;
            }
        },
        setUserCurrentSongs: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.setUserCurrentSongs(credentials)
        },
        getUserSubscribedCreators: ({ commit }, credentials) => {
          /*var data = {
            creators: ['asdasd','tomand','3232323','toma']
          };

          commit('SET_USER_SUB_CREATORS', data)
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.getUserSubscribedCreators(credentials)
              .then(({ data }) => {
                commit('SET_USER_SUB_CREATORS', data)
              })
        },
        logTrackerStart: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.logTrackerStart(credentials)
        },
        logTrackerEnd: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.logTrackerEnd(credentials)
        },
        logTrackerPause: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.logTrackerPause(credentials)
        },
        getCreatorTracks: ({ commit }, credentials) => {
          /*var data = {
            tracks: [
              {
                id: "DEFAULT019",
                timestamp: "2024-12-01 12:12:12",
                title: "Sleep With The Stars",
                artists_stream_w: [1], artists: ["Shimmer"],
                album: "",
                album_connected: [],
                channel_connected: [],
                explicit_text: 0, // czy jest tekst niecenzuralny/wykluczajacy
                publisher_timestamp: "2024-11-12 12:12:12", // czas publikacji zasobu
                publisher_info: "2024 Muzible", // wydawca zasobu
                similar_songs: [],
                excluded_countries: [],
                description: "A very low energy, ambient song that is best described as reflective and calm. Ambient tones and synth are the primary instruments in this track.",
                music_tags: ["very low energy", "ambient", "reflective", "calm"],
                music_genre: ["Ambient"],
                music_mood: ["Reflective","Calm","Peaceful","Mysterious"],
                music_movement: [],
                 
              
                art_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT019.avif",
                art: "https://cdn-img.muzible.com/tracks/default/DEFAULT019_200x200.avif",
                src: "https://cdn.s0.muzible.com/DEFAULT019/DEFAULT019_160kbps_backup.mp4",
                hlssrc: "https://cdn.s0.muzible.com/DEFAULT019/DEFAULT019.mpd",
              
                published: 1,
                stream_lvl: 0, // Poziom streama, 0 - darmowy (backup na lvl0 bucket), 1 - platny (backup na lvl1 bucket), 2 - platny Atmos (backup na lvl1 bucket)
                type: "muze", // muze, ticket, geo, global, podcast - informacje jak zostal dodany zasob i co zawiera (global to B2B streamy)
                playable: 1, // czy mozna odtworzyc 0 lub 1 - informacja dla playera - dodac mozan tylko utwory Playable. Domyslnie 1 dla muzyki.
                streamable: 1, // czy mozna streamowac 0 lub 1, inaczej albo owner albo creator albo sub(creatora) albo gerolokalizacyjny. Nie da sie zmienic ustawiany raz.
                public: 1, // czy jest publiczny 0 lub 1 - publiczy laduje w buckecie lvl0 oraz lvl0_flac i jest w jednej najlepszej wersji dostepny dla kazdego za darmo.
                // public owner zasobu moze zmienic z 0 na 1 lub z 1 na 0, wywoluje to przekodowanie muzyki i zmiane w bucketach (usuniecie starych i dodanie nowych lokalizacji,
                // podczas zmiany mozan podmienic jakosc utworu. Zmiany moze dokonac tylko creator zasobu i tylko dla obietkow ktore nie sa NFTkami lub Geo - czyli sa Streamowalne (NFT i GEO nie sa).
                stream_count: 0, // ile razy odtworzono, raz dziennie update licznikow
                creator: "Muzible", // tworca zasobu - nie mozan zmienic nigdy.
                creator_sub: 0, // czy creatora mozna subskrybowac 0 lub 1 - muzyka zaladowana ze B2B stream ma kreatora ogolnego, kreatorem moze byc tez Muzible, tacy kreatorzy nie sa subskrybowalni
                owner: "Muzible", // aktualny owner tego zasobu - wykorzystwane dla NFT, Lokalizacyjnych NFT, Ticketow. Takie zasoby sa zazwyczaj handlowalne.
                royalty_free: 1, // czy jest bezplatny jesli 1 to za streamowanie nikt nie placi, tzn ze jest darmowy i creator nie dostanie nic za odtworzenia. Glownie stosowane w NFT oraz publicznych zasobach (lvl0) (takze podcasty)
                stream_pps: 0, // level platnosci za streamowanie - 1 podstawowy, 2 - dla streamow Atmos - creatorzy atmos zarabiaja troche wiecej za odtworzenie.
                nft_is: 0, // jest nftkiem - moze byc NFTkiem streamable - wtedy owner aktualny zgarnia za streamy dzieli streamy (przychody) sie to na N ownerow i creatora.
                nft_totalsize: 0, // rozmiar dropa dla nft (-1) jesli unlimited - informacja o lacznym nakladzie danego NFT, jesli -1 to nie ma limitu 0 moze byc czasowy limit na claim NFT np geo/ticket.
                nft_number: 0, // numer nftka bue wuejszt niz nft_totalsize
                nft_start_price_usd: 0, // cena startowa nftka w usd ustawione na poziomie kolekcji badz osobno per NFT
                nft_start_price_muz: 0, // cena startowa nftka w muz ustawione na poziomie kolekcji badz osobno per NFT
                nft_merch: 0, // czy jest merch O lub 1 - wtedy mozab go uzyc w sklepie. Takie NFTki pojawia sie w Collections jako Merch
                nft_resale_to_creator_percent: 0, // % zysku dla tworcy przy kazdej odsprzedazy, standardowo 10% - mozna zmienic dla kazdego NFTka na od 0 do 50.
                nft_claim_end_time: "", // czas do kiedy mozna claimowac - glownie NFT lokalizacyjne i ticketowe (glownie takie unlimited ale nie musza byc unlimited)
                nft_bonus: 0, // czy jest bonusowy - jesli tak to dodatkowe bonusy dla ownera
                nft_bonus_type: "", // typ bonusu money - przypisane sa MUZy do tego NFTka - w czasie tworzenia przez artyste juz musza byc zdeponowane, podczas claimu/zmiany ownera pierwszy raz owner dostaje bonus
                // inne typy bonusow moga byc dodawane na biezaco i ich obsluga moze byc na poziomie pozniejszego mercha.
                nft_bonus_info: {}, // dodatkowe informacje o bonusie - np. ile MUZy, jakie prawa, jakie inne bonusy, jakie merch itp. info dla Engine bonusow
                nft_bonus_used: 0, // czy bonus juz byl uzyty - jesli tak to nie mozna go juz uzyc, moze zalezec od typu bonusa. Obsluga po stronie backendu tylko. (bonus engine)
                geo_link: "", // link do lokalizacji geo - zobacyzmy gdzie dokladnie - moze google maps czy cos innego..
                geo_time_until: "", // czas do kiedy jest widoczny w geolokacji, jesli pusty to widocznosc bez konca, jesli widocznosc minie to zasob zwraca src: domyslny dzwiek dla wszystkich niedostepnych.
                geo_location_lon: "", // lokalizacja geograficzna
                geo_location_lat: "", // lokalizacja geograficzna
                geo_location_radius: 0, // promien lokalizacji we metrach na jaka odleglosc lapie lokalizacja
                // Geo powinna byc skanowalna albo nie skanowalna - wtedy wystarczy byc w lokalizacji (badz byc ownerem/creatorem),
                // Jak jest nie skanowalny GEO NFT to w lokalizacji mozna odtworzyc ale mozna tez kupic takiego NFT i odtwarzac poza lokalizacja.
                // Jesli skanowalna - trzeba najpierw sie przejsc do lokalizacji i tam zeskanowac i zclaimowac NFTka, wtedy jest juz odtwarzalny poza lokalizacja i mozna nim tez handlowac.
                // W obu przypoadkach, jesli ktos jest w lokalizacji to moze odtworzyc nawte jak nie ma NTka - chyba ze geo_time_until jest przekroczony - wtedy tylko owner/creator.
                // Jesli jest to GEO NFT - to obiekt GEO NFT
                geo_can_play_in_location_non_owner: 1, // czy nie bedac ownerem/creatorem mozna odtworzyc bedac w lokalizacji
                geo_nft_scan: 0, // czy jest skanowana i to wystarcza aby nabyc - trzeba przyjsc do lokalizacji zeskanow i wtedy mozan claimowac NFTka (jesli wciaz dostepny)
                geo_nft_buy: 0, // czy jest kupowalny i mozna kupic przed odtworzeniem - troche w ciemno zostac wlascicielem praw do zasobu (geo nie sa streamowalne!). Wciaz moze byc tak ze
                // po kupnie trzeba przejsc do lokalizacji zeby zeskanowac i zclaimowac NFTka, zasob GEO NFT  moze dawac prawa do odtworzenia muzyki poza lokalizacja, oraz inne dowolne, ale moze tez:
                // podczas Claimu w lokalizacji,
                geo_nfts: [], // jesli jest NFTkiem to lista NFTkow ktore sa wlasnoscia tego obiektu - mozna miec kilka NFTkow na jednym obiekcie
                // Te NFtki sa wczesniej stworzone przez tworce, moga byc playable i non playble, nie moga byc streamable. moga zawierac merch. kazdy GEO NFT ma swoj ID i moze miec przypisane dodatkowe unikatowe NFTki
                // GEO NFt szeruja naotmiast wspolne dane nie zmienialne, tak by czas, dostepnosc, ilosc, lokalizacja zawsze byly te same.
                // Beda w lokalizacji z obiektem geo_nft_scan : 1, pojawi sie lista NFTkow ktore mozna claimowac - nie widzimy co zawieraja (geo_nfts) ale widzimy ile jest NFTkow do claimowania i sami dokonujemy wyboru z dostepnych
                // Wtedy po claimowaniu dostajemy dostep do zasobu i mozemy go odtwarzac poza lokalizacja, ponadto stajemy sie tez ownerem geo_nfts - ktore UWAGA! - moga zawierac dodatki/bonusy(glownie non-playable).
                ai_gen: 0, // informacja czy zasob zostal wygenerowane przez AI (muze engine)
                ai_gen_prompt: "", // informacja jakie byly parametry generacji
                ai_gen_score: 0, // jakosc generacji - 0-100 - ocenia uzytkownik ktory generowal (raz)
                ai_gen_mood: 0, // informacja czy zostal wygenerowany na podstawie zdjecia (muze engine)
                ai_gen_mood_link: "", // link do zdjecia z ktorego generowano muzyke (w muze engine)
                // Lokalizacje plikow wszystkich leveli + lokalizacja oryginalu nie widoczne na zewnatrz - zapisane po skanowaniu i generacji plikow
                nv_link_flac: "",
                nv_link_atmos: "",
                nv_link_768: "",
                nv_link_320: "https://cdn.s0.muzible.com/DEFAULT019/DEFAULT019.mpd",
                nv_link_backup: "https://cdn.s0.muzible.com/DEFAULT019/DEFAULT019_160kbps_backup.mp4",
                nv_link_preview: "https://cdn.s0p.muzible.com/DEFAULT019/DEFAULT019_160kbps_preview.mp4",
                nv_link_raw_file: "s3://muzible-music-raw/stream-free/default_music/Shimmer_Sleep_With_The_Stars_528_Hz_background_vocals_4_24.mp3",
                nv_link_creator: "https://cdn.c0.muzible.com/MUZIBLE/DEFAULT019.mpd",
                nv_has_flac: 0,
                nv_has_atmos: 0,
                nv_has_768: 0,
                nv_has_320: 1,
                nv_has_backup: 1,
                nv_has_preview: 1,
                nv_has_creator: 1, duration: "4:24",
              },
              {
                id: "DEFAULT020",
                timestamp: "2024-12-01 12:12:12",
                title: "Sloth Tier Jazz",
                artists_stream_w: [1], artists: ["Lazy Chill Zone"],
                album: "",
                album_connected: [],
                channel_connected: [],
                explicit_text: 0, // czy jest tekst niecenzuralny/wykluczajacy
                publisher_timestamp: "2024-11-12 12:12:12", // czas publikacji zasobu
                publisher_info: "2024 Muzible", // wydawca zasobu
                similar_songs: [],
                excluded_countries: [],
                description: "Jazz, Lofi jazz, Lofi music.",
                music_tags: ["background music", "jazz", "lofi", "lofi jazz"],
                music_genre: ["Hip Hop", "Rnb", "Beats"],
                music_mood: ["Glamorous","Bright","Dreamy","Romantic"],
                music_movement: ["Smooth","Elegant","Medium"],
                 
              
                art_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT020.webp",
                art: "https://cdn-img.muzible.com/tracks/default/DEFAULT020_200x200.webp",
                src: "https://cdn.s0.muzible.com/DEFAULT020/DEFAULT020_160kbps_backup.mp4",
                hlssrc: "https://cdn.s0.muzible.com/DEFAULT020/DEFAULT020.mpd",
              
                published: 1,
                stream_lvl: 0, // Poziom streama, 0 - darmowy (backup na lvl0 bucket), 1 - platny (backup na lvl1 bucket), 2 - platny Atmos (backup na lvl1 bucket)
                type: "muze", // muze, ticket, geo, global, podcast - informacje jak zostal dodany zasob i co zawiera (global to B2B streamy)
                playable: 1, // czy mozna odtworzyc 0 lub 1 - informacja dla playera - dodac mozan tylko utwory Playable. Domyslnie 1 dla muzyki.
                streamable: 1, // czy mozna streamowac 0 lub 1, inaczej albo owner albo creator albo sub(creatora) albo gerolokalizacyjny. Nie da sie zmienic ustawiany raz.
                public: 1, // czy jest publiczny 0 lub 1 - publiczy laduje w buckecie lvl0 oraz lvl0_flac i jest w jednej najlepszej wersji dostepny dla kazdego za darmo.
                // public owner zasobu moze zmienic z 0 na 1 lub z 1 na 0, wywoluje to przekodowanie muzyki i zmiane w bucketach (usuniecie starych i dodanie nowych lokalizacji,
                // podczas zmiany mozan podmienic jakosc utworu. Zmiany moze dokonac tylko creator zasobu i tylko dla obietkow ktore nie sa NFTkami lub Geo - czyli sa Streamowalne (NFT i GEO nie sa).
                stream_count: 0, // ile razy odtworzono, raz dziennie update licznikow
                creator: "Muzible", // tworca zasobu - nie mozan zmienic nigdy.
                creator_sub: 0, // czy creatora mozna subskrybowac 0 lub 1 - muzyka zaladowana ze B2B stream ma kreatora ogolnego, kreatorem moze byc tez Muzible, tacy kreatorzy nie sa subskrybowalni
                owner: "Muzible", // aktualny owner tego zasobu - wykorzystwane dla NFT, Lokalizacyjnych NFT, Ticketow. Takie zasoby sa zazwyczaj handlowalne.
                royalty_free: 1, // czy jest bezplatny jesli 1 to za streamowanie nikt nie placi, tzn ze jest darmowy i creator nie dostanie nic za odtworzenia. Glownie stosowane w NFT oraz publicznych zasobach (lvl0) (takze podcasty)
                stream_pps: 0, // level platnosci za streamowanie - 1 podstawowy, 2 - dla streamow Atmos - creatorzy atmos zarabiaja troche wiecej za odtworzenie.
                nft_is: 0, // jest nftkiem - moze byc NFTkiem streamable - wtedy owner aktualny zgarnia za streamy dzieli streamy (przychody) sie to na N ownerow i creatora.
                nft_totalsize: 0, // rozmiar dropa dla nft (-1) jesli unlimited - informacja o lacznym nakladzie danego NFT, jesli -1 to nie ma limitu 0 moze byc czasowy limit na claim NFT np geo/ticket.
                nft_number: 0, // numer nftka bue wuejszt niz nft_totalsize
                nft_start_price_usd: 0, // cena startowa nftka w usd ustawione na poziomie kolekcji badz osobno per NFT
                nft_start_price_muz: 0, // cena startowa nftka w muz ustawione na poziomie kolekcji badz osobno per NFT
                nft_merch: 0, // czy jest merch O lub 1 - wtedy mozab go uzyc w sklepie. Takie NFTki pojawia sie w Collections jako Merch
                nft_resale_to_creator_percent: 0, // % zysku dla tworcy przy kazdej odsprzedazy, standardowo 10% - mozna zmienic dla kazdego NFTka na od 0 do 50.
                nft_claim_end_time: "", // czas do kiedy mozna claimowac - glownie NFT lokalizacyjne i ticketowe (glownie takie unlimited ale nie musza byc unlimited)
                nft_bonus: 0, // czy jest bonusowy - jesli tak to dodatkowe bonusy dla ownera
                nft_bonus_type: "", // typ bonusu money - przypisane sa MUZy do tego NFTka - w czasie tworzenia przez artyste juz musza byc zdeponowane, podczas claimu/zmiany ownera pierwszy raz owner dostaje bonus
                // inne typy bonusow moga byc dodawane na biezaco i ich obsluga moze byc na poziomie pozniejszego mercha.
                nft_bonus_info: {}, // dodatkowe informacje o bonusie - np. ile MUZy, jakie prawa, jakie inne bonusy, jakie merch itp. info dla Engine bonusow
                nft_bonus_used: 0, // czy bonus juz byl uzyty - jesli tak to nie mozna go juz uzyc, moze zalezec od typu bonusa. Obsluga po stronie backendu tylko. (bonus engine)
                geo_link: "", // link do lokalizacji geo - zobacyzmy gdzie dokladnie - moze google maps czy cos innego..
                geo_time_until: "", // czas do kiedy jest widoczny w geolokacji, jesli pusty to widocznosc bez konca, jesli widocznosc minie to zasob zwraca src: domyslny dzwiek dla wszystkich niedostepnych.
                geo_location_lon: "", // lokalizacja geograficzna
                geo_location_lat: "", // lokalizacja geograficzna
                geo_location_radius: 0, // promien lokalizacji we metrach na jaka odleglosc lapie lokalizacja
                // Geo powinna byc skanowalna albo nie skanowalna - wtedy wystarczy byc w lokalizacji (badz byc ownerem/creatorem),
                // Jak jest nie skanowalny GEO NFT to w lokalizacji mozna odtworzyc ale mozna tez kupic takiego NFT i odtwarzac poza lokalizacja.
                // Jesli skanowalna - trzeba najpierw sie przejsc do lokalizacji i tam zeskanowac i zclaimowac NFTka, wtedy jest juz odtwarzalny poza lokalizacja i mozna nim tez handlowac.
                // W obu przypoadkach, jesli ktos jest w lokalizacji to moze odtworzyc nawte jak nie ma NTka - chyba ze geo_time_until jest przekroczony - wtedy tylko owner/creator.
                // Jesli jest to GEO NFT - to obiekt GEO NFT
                geo_can_play_in_location_non_owner: 1, // czy nie bedac ownerem/creatorem mozna odtworzyc bedac w lokalizacji
                geo_nft_scan: 0, // czy jest skanowana i to wystarcza aby nabyc - trzeba przyjsc do lokalizacji zeskanow i wtedy mozan claimowac NFTka (jesli wciaz dostepny)
                geo_nft_buy: 0, // czy jest kupowalny i mozna kupic przed odtworzeniem - troche w ciemno zostac wlascicielem praw do zasobu (geo nie sa streamowalne!). Wciaz moze byc tak ze
                // po kupnie trzeba przejsc do lokalizacji zeby zeskanowac i zclaimowac NFTka, zasob GEO NFT  moze dawac prawa do odtworzenia muzyki poza lokalizacja, oraz inne dowolne, ale moze tez:
                // podczas Claimu w lokalizacji,
                geo_nfts: [], // jesli jest NFTkiem to lista NFTkow ktore sa wlasnoscia tego obiektu - mozna miec kilka NFTkow na jednym obiekcie
                // Te NFtki sa wczesniej stworzone przez tworce, moga byc playable i non playble, nie moga byc streamable. moga zawierac merch. kazdy GEO NFT ma swoj ID i moze miec przypisane dodatkowe unikatowe NFTki
                // GEO NFt szeruja naotmiast wspolne dane nie zmienialne, tak by czas, dostepnosc, ilosc, lokalizacja zawsze byly te same.
                // Beda w lokalizacji z obiektem geo_nft_scan : 1, pojawi sie lista NFTkow ktore mozna claimowac - nie widzimy co zawieraja (geo_nfts) ale widzimy ile jest NFTkow do claimowania i sami dokonujemy wyboru z dostepnych
                // Wtedy po claimowaniu dostajemy dostep do zasobu i mozemy go odtwarzac poza lokalizacja, ponadto stajemy sie tez ownerem geo_nfts - ktore UWAGA! - moga zawierac dodatki/bonusy(glownie non-playable).
                ai_gen: 0, // informacja czy zasob zostal wygenerowane przez AI (muze engine)
                ai_gen_prompt: "", // informacja jakie byly parametry generacji
                ai_gen_score: 0, // jakosc generacji - 0-100 - ocenia uzytkownik ktory generowal (raz)
                ai_gen_mood: 0, // informacja czy zostal wygenerowany na podstawie zdjecia (muze engine)
                ai_gen_mood_link: "", // link do zdjecia z ktorego generowano muzyke (w muze engine)
                // Lokalizacje plikow wszystkich leveli + lokalizacja oryginalu nie widoczne na zewnatrz - zapisane po skanowaniu i generacji plikow
                nv_link_flac: "",
                nv_link_atmos: "",
                nv_link_768: "",
                nv_link_320: "https://cdn.s0.muzible.com/DEFAULT020/DEFAULT020.mpd",
                nv_link_backup: "https://cdn.s0.muzible.com/DEFAULT020/DEFAULT020_160kbps_backup.mp4",
                nv_link_preview: "https://cdn.s0p.muzible.com/DEFAULT020/DEFAULT020_160kbps_preview.mp4",
                nv_link_raw_file: "s3://muzible-music-raw/stream-free/default_music/sloth-tier-lofi-jazz-223593.mp3",
                nv_link_creator: "https://cdn.c0.muzible.com/MUZIBLE/DEFAULT020.mpd",
                nv_has_flac: 0,
                nv_has_atmos: 0,
                nv_has_768: 0,
                nv_has_320: 1,
                nv_has_backup: 1,
                nv_has_preview: 1,
                nv_has_creator: 1, duration: "3:56",
              },
            ]
          };
          const promise = Promise.resolve(data);
          return promise;*/

          return EventService.getCreatorTracks(credentials)
        },
        getArtistTracks: ({ commit }, credentials) => {
          /*var data = {
            tracks: [
              {
                id: "DEFAULT001",
                timestamp: "2024-12-01 12:12:12",
                title: "Abstract Technology",
                artists_stream_w: [1], artists: ["NRA-LAB"],
                album: "",
                album_connected: [],
                channel_connected: [],
                explicit_text: 0, // czy jest tekst niecenzuralny/wykluczajacy
                publisher_timestamp: "2024-11-12 12:12:12", // czas publikacji zasobu
                publisher_info: "2024 Muzible", // wydawca zasobu
                similar_songs: [],
                excluded_countries: [],
                description: "Invitation, Unstoppable, Journey music.",
                music_tags: ["magnetic", "emotional", "piano", "sci fi", "india", "krishna", "journey"],
                music_genre: ["Future Bass", "Beats", "Electronic", "Corporate"],
                music_mood: ["Dreamy", "Hopeful", "Bright", "Uplifting"],
                music_movement: ["Floating", "Smooth", "Chasing", "Medium", "Elegant"],
                
                art_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT001.webp",
                art: "https://cdn-img.muzible.com/tracks/default/DEFAULT001_200x200.webp",
                src: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001_160kbps_backup.mp4",
                hlssrc: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001.mpd",
                
                published: 1,
                stream_lvl: 0, // Poziom streama, 0 - darmowy (backup na lvl0 bucket), 1 - platny (backup na lvl1 bucket), 2 - platny Atmos (backup na lvl1 bucket)
                type: "muze", // muze, ticket, geo, global, podcast - informacje jak zostal dodany zasob i co zawiera (global to B2B streamy)
                playable: 1, // czy mozna odtworzyc 0 lub 1 - informacja dla playera - dodac mozan tylko utwory Playable. Domyslnie 1 dla muzyki.
                streamable: 1, // czy mozna streamowac 0 lub 1, inaczej albo owner albo creator albo sub(creatora) albo gerolokalizacyjny. Nie da sie zmienic ustawiany raz.
                public: 1, // czy jest publiczny 0 lub 1 - publiczy laduje w buckecie lvl0 oraz lvl0_flac i jest w jednej najlepszej wersji dostepny dla kazdego za darmo.
                // public owner zasobu moze zmienic z 0 na 1 lub z 1 na 0, wywoluje to przekodowanie muzyki i zmiane w bucketach (usuniecie starych i dodanie nowych lokalizacji,
                // podczas zmiany mozan podmienic jakosc utworu. Zmiany moze dokonac tylko creator zasobu i tylko dla obietkow ktore nie sa NFTkami lub Geo - czyli sa Streamowalne (NFT i GEO nie sa).
                stream_count: 0, // ile razy odtworzono, raz dziennie update licznikow
                creator: "Muzible", // tworca zasobu - nie mozan zmienic nigdy.
                creator_sub: 0, // czy creatora mozna subskrybowac 0 lub 1 - muzyka zaladowana ze B2B stream ma kreatora ogolnego, kreatorem moze byc tez Muzible, tacy kreatorzy nie sa subskrybowalni
                owner: "Muzible", // aktualny owner tego zasobu - wykorzystwane dla NFT, Lokalizacyjnych NFT, Ticketow. Takie zasoby sa zazwyczaj handlowalne.
                royalty_free: 1, // czy jest bezplatny jesli 1 to za streamowanie nikt nie placi, tzn ze jest darmowy i creator nie dostanie nic za odtworzenia. Glownie stosowane w NFT oraz publicznych zasobach (lvl0) (takze podcasty)
                stream_pps: 0, // level platnosci za streamowanie - 1 podstawowy, 2 - dla streamow Atmos - creatorzy atmos zarabiaja troche wiecej za odtworzenie.
                nft_is: 0, // jest nftkiem - moze byc NFTkiem streamable - wtedy owner aktualny zgarnia za streamy dzieli streamy (przychody) sie to na N ownerow i creatora.
                nft_totalsize: 0, // rozmiar dropa dla nft (-1) jesli unlimited - informacja o lacznym nakladzie danego NFT, jesli -1 to nie ma limitu 0 moze byc czasowy limit na claim NFT np geo/ticket.
                nft_number: 0, // numer nftka bue wuejszt niz nft_totalsize
                nft_start_price_usd: 0, // cena startowa nftka w usd ustawione na poziomie kolekcji badz osobno per NFT
                nft_start_price_muz: 0, // cena startowa nftka w muz ustawione na poziomie kolekcji badz osobno per NFT
                nft_merch: 0, // czy jest merch O lub 1 - wtedy mozab go uzyc w sklepie. Takie NFTki pojawia sie w Collections jako Merch
                nft_resale_to_creator_percent: 0, // % zysku dla tworcy przy kazdej odsprzedazy, standardowo 10% - mozna zmienic dla kazdego NFTka na od 0 do 50.
                nft_claim_end_time: "", // czas do kiedy mozna claimowac - glownie NFT lokalizacyjne i ticketowe (glownie takie unlimited ale nie musza byc unlimited)
                nft_bonus: 0, // czy jest bonusowy - jesli tak to dodatkowe bonusy dla ownera
                nft_bonus_type: "", // typ bonusu money - przypisane sa MUZy do tego NFTka - w czasie tworzenia przez artyste juz musza byc zdeponowane, podczas claimu/zmiany ownera pierwszy raz owner dostaje bonus
                // inne typy bonusow moga byc dodawane na biezaco i ich obsluga moze byc na poziomie pozniejszego mercha.
                nft_bonus_info: {}, // dodatkowe informacje o bonusie - np. ile MUZy, jakie prawa, jakie inne bonusy, jakie merch itp. info dla Engine bonusow
                nft_bonus_used: 0, // czy bonus juz byl uzyty - jesli tak to nie mozna go juz uzyc, moze zalezec od typu bonusa. Obsluga po stronie backendu tylko. (bonus engine)
                geo_link: "", // link do lokalizacji geo - zobacyzmy gdzie dokladnie - moze google maps czy cos innego..
                geo_time_until: "", // czas do kiedy jest widoczny w geolokacji, jesli pusty to widocznosc bez konca, jesli widocznosc minie to zasob zwraca src: domyslny dzwiek dla wszystkich niedostepnych.
                geo_location_lon: "", // lokalizacja geograficzna
                geo_location_lat: "", // lokalizacja geograficzna
                geo_location_radius: 0, // promien lokalizacji we metrach na jaka odleglosc lapie lokalizacja
                // Geo powinna byc skanowalna albo nie skanowalna - wtedy wystarczy byc w lokalizacji (badz byc ownerem/creatorem),
                // Jak jest nie skanowalny GEO NFT to w lokalizacji mozna odtworzyc ale mozna tez kupic takiego NFT i odtwarzac poza lokalizacja.
                // Jesli skanowalna - trzeba najpierw sie przejsc do lokalizacji i tam zeskanowac i zclaimowac NFTka, wtedy jest juz odtwarzalny poza lokalizacja i mozna nim tez handlowac.
                // W obu przypoadkach, jesli ktos jest w lokalizacji to moze odtworzyc nawte jak nie ma NTka - chyba ze geo_time_until jest przekroczony - wtedy tylko owner/creator.
                // Jesli jest to GEO NFT - to obiekt GEO NFT
                geo_can_play_in_location_non_owner: 1, // czy nie bedac ownerem/creatorem mozna odtworzyc bedac w lokalizacji
                geo_nft_scan: 0, // czy jest skanowana i to wystarcza aby nabyc - trzeba przyjsc do lokalizacji zeskanow i wtedy mozan claimowac NFTka (jesli wciaz dostepny)
                geo_nft_buy: 0, // czy jest kupowalny i mozna kupic przed odtworzeniem - troche w ciemno zostac wlascicielem praw do zasobu (geo nie sa streamowalne!). Wciaz moze byc tak ze
                // po kupnie trzeba przejsc do lokalizacji zeby zeskanowac i zclaimowac NFTka, zasob GEO NFT  moze dawac prawa do odtworzenia muzyki poza lokalizacja, oraz inne dowolne, ale moze tez:
                // podczas Claimu w lokalizacji,
                geo_nfts: [], // jesli jest NFTkiem to lista NFTkow ktore sa wlasnoscia tego obiektu - mozna miec kilka NFTkow na jednym obiekcie
                // Te NFtki sa wczesniej stworzone przez tworce, moga byc playable i non playble, nie moga byc streamable. moga zawierac merch. kazdy GEO NFT ma swoj ID i moze miec przypisane dodatkowe unikatowe NFTki
                // GEO NFt szeruja naotmiast wspolne dane nie zmienialne, tak by czas, dostepnosc, ilosc, lokalizacja zawsze byly te same.
                // Beda w lokalizacji z obiektem geo_nft_scan : 1, pojawi sie lista NFTkow ktore mozna claimowac - nie widzimy co zawieraja (geo_nfts) ale widzimy ile jest NFTkow do claimowania i sami dokonujemy wyboru z dostepnych
                // Wtedy po claimowaniu dostajemy dostep do zasobu i mozemy go odtwarzac poza lokalizacja, ponadto stajemy sie tez ownerem geo_nfts - ktore UWAGA! - moga zawierac dodatki/bonusy(glownie non-playable).
                ai_gen: 0, // informacja czy zasob zostal wygenerowane przez AI (muze engine)
                ai_gen_prompt: "", // informacja jakie byly parametry generacji
                ai_gen_score: 0, // jakosc generacji - 0-100 - ocenia uzytkownik ktory generowal (raz)
                ai_gen_mood: 0, // informacja czy zostal wygenerowany na podstawie zdjecia (muze engine)
                ai_gen_mood_link: "", // link do zdjecia z ktorego generowano muzyke (w muze engine)
                // Lokalizacje plikow wszystkich leveli + lokalizacja oryginalu nie widoczne na zewnatrz - zapisane po skanowaniu i generacji plikow
                nv_link_flac: "",
                nv_link_atmos: "",
                nv_link_768: "",
                nv_link_320: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001.mpd",
                nv_link_backup: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001_160kbps_backup.mp4",
                nv_link_preview: "https://cdn.s0p.muzible.com/DEFAULT001/DEFAULT001_160kbps_preview.mp4",
                nv_link_raw_file: "s3://muzible-music-raw/stream-free/default_music/abstract-technology-pixelated-futures-230634.mp3",
                nv_link_creator: "https://cdn.c0.muzible.com/MUZIBLE/DEFAULT001.mpd",
                nv_has_flac: 0,
                nv_has_atmos: 0,
                nv_has_768: 0,
                nv_has_320: 1,
                nv_has_backup: 1,
                nv_has_preview: 1,
                nv_has_creator: 1, duration: "2:24",
              },
            ]
          };
          const promise = Promise.resolve(data);
          return promise;*/

          return EventService.getArtistTracks(credentials)
        },
        getPlaylistTracks: ({ commit }, credentials) => {
          /*var data = {
            tracks: [
              {
                id: "DEFAULT004",
                timestamp: "2024-12-01 12:12:12",
                title: "Magic Garden [Wroclaw Location Exclusive]",
                artists: ["Daniele Musto"],
                album: "",
                album_connected: [],
                channel_connected: [],
                explicit_text: 0, // czy jest tekst niecenzuralny/wykluczajacy
                publisher_timestamp: "2024-11-12 12:12:12", // czas publikacji zasobu
                publisher_info: "2024 Muzible", // wydawca zasobu
                similar_songs: [],
                excluded_countries: [],
                description: "A very low energy, hip hop song that is best described as chill and reflective. Synth and bass are the primary instruments in this track.",
                music_tags: ["synth", "bass", "hip hop", "low energy"],
                music_genre: ["Synthwave", "Modern Pop"],
                music_mood: ["Chill", "Reflective"],
                music_movement: [],
                 
              
                art_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT004.avif",
                art: "https://cdn-img.muzible.com/tracks/default/DEFAULT004_200x200.avif",
                src: "https://cdn.s0p.muzible.com/DEFAULT004/DEFAULT004_160kbps_preview.mp4", // Albo preview(inside=0) albo Backup jesli (inside=1)
                hlssrc: "", // Albo puste albo .mpd link jesli (inside=1)
                // https://cdn.s0.muzible.com/DEFAULT004/DEFAULT004.mpd
              
                published: 1,
                stream_lvl: 0, // Poziom streama, 0 - darmowy (backup na lvl0 bucket), 1 - platny (backup na lvl1 bucket), 2 - platny Atmos (backup na lvl1 bucket)
                type: "geo", // muze, ticket, geo, global - informacje jak zostal dodany zasob i co zawiera (global to B2B streamy)
                playable: 1, // czy mozna odtworzyc 0 lub 1 - informacja dla playera - dodac mozan tylko utwory Playable. Domyslnie 1 dla muzyki.
                streamable: 0, // czy mozna streamowac 0 lub 1, inaczej albo owner albo creator albo sub(creatora) albo gerolokalizacyjny. Nie da sie zmienic ustawiany raz.
                public: 1, // czy jest publiczny 0 lub 1 - publiczy laduje w buckecie lvl0 oraz lvl0_flac i jest w jednej najlepszej wersji dostepny dla kazdego za darmo.
                // public owner zasobu moze zmienic z 0 na 1 lub z 1 na 0, wywoluje to przekodowanie muzyki i zmiane w bucketach (usuniecie starych i dodanie nowych lokalizacji,
                // podczas zmiany mozan podmienic jakosc utworu. Zmiany moze dokonac tylko creator zasobu i tylko dla obietkow ktore nie sa NFTkami lub Geo - czyli sa Streamowalne (NFT i GEO nie sa).
                stream_count: 0, // ile razy odtworzono, raz dziennie update licznikow
                creator: "Muzible", // tworca zasobu - nie mozan zmienic nigdy.
                creator_sub: 0, // czy creatora mozna subskrybowac 0 lub 1 - muzyka zaladowana ze B2B stream ma kreatora ogolnego, kreatorem moze byc tez Muzible, tacy kreatorzy nie sa subskrybowalni
                owner: "Muzible", // aktualny owner tego zasobu - wykorzystwane dla NFT, Lokalizacyjnych NFT, Ticketow. Takie zasoby sa zazwyczaj handlowalne.
                royalty_free: 1, // czy jest bezplatny jesli 1 to za streamowanie nikt nie placi, tzn ze jest darmowy i creator nie dostanie nic za odtworzenia. Glownie stosowane w NFT oraz publicznych zasobach (lvl0) (takze podcasty)
                stream_pps: 0, // level platnosci za streamowanie - 1 podstawowy, 2 - dla streamow Atmos - creatorzy atmos zarabiaja troche wiecej za odtworzenie.
                nft_is: 0, // jest nftkiem - moze byc NFTkiem streamable - wtedy owner aktualny zgarnia za streamy dzieli streamy (przychody) sie to na N ownerow i creatora.
                nft_totalsize: 0, // rozmiar dropa dla nft (-1) jesli unlimited - informacja o lacznym nakladzie danego NFT, jesli -1 to nie ma limitu 0 moze byc czasowy limit na claim NFT np geo/ticket.
                nft_number: 0, // numer nftka bue wuejszt niz nft_totalsize
                nft_start_price_usd: 0, // cena startowa nftka w usd ustawione na poziomie kolekcji badz osobno per NFT
                nft_start_price_muz: 0, // cena startowa nftka w muz ustawione na poziomie kolekcji badz osobno per NFT
                nft_merch: 0, // czy jest merch O lub 1 - wtedy mozab go uzyc w sklepie. Takie NFTki pojawia sie w Collections jako Merch
                nft_resale_to_creator_percent: 0, // % zysku dla tworcy przy kazdej odsprzedazy, standardowo 10% - mozna zmienic dla kazdego NFTka na od 0 do 50.
                nft_claim_end_time: "", // czas do kiedy mozna claimowac - glownie NFT lokalizacyjne i ticketowe (glownie takie unlimited ale nie musza byc unlimited)
                nft_bonus: 0, // czy jest bonusowy - jesli tak to dodatkowe bonusy dla ownera
                nft_bonus_type: "", // typ bonusu money - przypisane sa MUZy do tego NFTka - w czasie tworzenia przez artyste juz musza byc zdeponowane, podczas claimu/zmiany ownera pierwszy raz owner dostaje bonus
                // inne typy bonusow moga byc dodawane na biezaco i ich obsluga moze byc na poziomie pozniejszego mercha.
                nft_bonus_info: {}, // dodatkowe informacje o bonusie - np. ile MUZy, jakie prawa, jakie inne bonusy, jakie merch itp. info dla Engine bonusow
                nft_bonus_used: 0, // czy bonus juz byl uzyty - jesli tak to nie mozna go juz uzyc, moze zalezec od typu bonusa. Obsluga po stronie backendu tylko. (bonus engine)
                geo_link: "https://www.google.pl/maps/place/Monument+of+Alexander+Fredro/@51.1100012,17.0332499,806m/", // link do lokalizacji geo - zobacyzmy gdzie dokladnie - moze google maps czy cos innego..
                geo_time_until: "", // czas do kiedy jest widoczny w geolokacji, jesli pusty to widocznosc bez konca, jesli widocznosc minie to zasob zwraca src: domyslny dzwiek dla wszystkich niedostepnych.
                geo_location_lon: "17.031324816478882", // lokalizacja geograficzna
                geo_location_lat: "51.109756493313775", // lokalizacja geograficzna
                geo_location_radius: 15000, // promien lokalizacji we metrach na jaka odleglosc lapie lokalizacja
                // Geo powinna byc skanowalna albo nie skanowalna - wtedy wystarczy byc w lokalizacji (badz byc ownerem/creatorem),
                // Jak jest nie skanowalny GEO NFT to w lokalizacji mozna odtworzyc ale mozna tez kupic takiego NFT i odtwarzac poza lokalizacja.
                // Jesli skanowalna - trzeba najpierw sie przejsc do lokalizacji i tam zeskanowac i zclaimowac NFTka, wtedy jest juz odtwarzalny poza lokalizacja i mozna nim tez handlowac.
                // W obu przypoadkach, jesli ktos jest w lokalizacji to moze odtworzyc nawte jak nie ma NTka - chyba ze geo_time_until jest przekroczony - wtedy tylko owner/creator.
                // Jesli jest to GEO NFT - to obiekt GEO NFT
                geo_can_play_in_location_non_owner: 1, // czy nie bedac ownerem/creatorem mozna odtworzyc bedac w lokalizacji
                geo_nft_scan: 0, // czy jest skanowana i to wystarcza aby nabyc - trzeba przyjsc do lokalizacji zeskanow i wtedy mozan claimowac NFTka (jesli wciaz dostepny)
                geo_nft_buy: 0, // czy jest kupowalny i mozna kupic przed odtworzeniem - troche w ciemno zostac wlascicielem praw do zasobu (geo nie sa streamowalne!). Wciaz moze byc tak ze
                // po kupnie trzeba przejsc do lokalizacji zeby zeskanowac i zclaimowac NFTka, zasob GEO NFT  moze dawac prawa do odtworzenia muzyki poza lokalizacja, oraz inne dowolne, ale moze tez:
                // podczas Claimu w lokalizacji,
                geo_nfts: [], // jesli jest NFTkiem to lista NFTkow ktore sa wlasnoscia tego obiektu - mozna miec kilka NFTkow na jednym obiekcie
                // Te NFtki sa wczesniej stworzone przez tworce, moga byc playable i non playble, nie moga byc streamable. moga zawierac merch. kazdy GEO NFT ma swoj ID i moze miec przypisane dodatkowe unikatowe NFTki
                // GEO NFt szeruja naotmiast wspolne dane nie zmienialne, tak by czas, dostepnosc, ilosc, lokalizacja zawsze byly te same.
                // Beda w lokalizacji z obiektem geo_nft_scan : 1, pojawi sie lista NFTkow ktore mozna claimowac - nie widzimy co zawieraja (geo_nfts) ale widzimy ile jest NFTkow do claimowania i sami dokonujemy wyboru z dostepnych
                // Wtedy po claimowaniu dostajemy dostep do zasobu i mozemy go odtwarzac poza lokalizacja, ponadto stajemy sie tez ownerem geo_nfts - ktore UWAGA! - moga zawierac dodatki/bonusy(glownie non-playable).
                ai_gen: 0, // informacja czy zasob zostal wygenerowane przez AI (muze engine)
                ai_gen_prompt: "", // informacja jakie byly parametry generacji
                ai_gen_score: 0, // jakosc generacji - 0-100 - ocenia uzytkownik ktory generowal (raz)
                ai_gen_mood: 0, // informacja czy zostal wygenerowany na podstawie zdjecia (muze engine)
                ai_gen_mood_link: "", // link do zdjecia z ktorego generowano muzyke (w muze engine)
                // Lokalizacje plikow wszystkich leveli + lokalizacja oryginalu nie widoczne na zewnatrz - zapisane po skanowaniu i generacji plikow
                nv_link_flac: "",
                nv_link_atmos: "",
                nv_link_768: "",
                nv_link_320: "https://cdn.s0.muzible.com/DEFAULT004/DEFAULT004.mpd",
                nv_link_backup: "https://cdn.s0.muzible.com/DEFAULT004/DEFAULT004_160kbps_backup.mp4",
                nv_link_preview: "https://cdn.s0p.muzible.com/DEFAULT004/DEFAULT004_160kbps_preview.mp4",
                nv_link_raw_file: "s3://muzible-music-raw/stream-free/default_music/Daniele_Musto_Magic_Garden_background_vocals_2_25.mp3",
                nv_link_creator: "https://cdn.c0.muzible.com/MUZIBLE/DEFAULT004.mpd",
                nv_has_flac: 0,
                nv_has_atmos: 0,
                nv_has_768: 0,
                nv_has_320: 1,
                nv_has_backup: 1,
                nv_has_preview: 1,
                nv_has_creator: 1, duration: "2:25",
              },
              {
                id: "DEFAULT005",
                timestamp: "2024-12-01 12:12:12",
                title: "Soledad [WARSAW Location Exclusive]",
                artists: ["Dario Benedetti"],
                album: "",
                album_connected: [],
                channel_connected: [],
                explicit_text: 0, // czy jest tekst niecenzuralny/wykluczajacy
                publisher_timestamp: "2024-11-12 12:12:12", // czas publikacji zasobu
                publisher_info: "2024 Muzible", // wydawca zasobu
                similar_songs: [],
                excluded_countries: [],
                description: "A medium energy, acoustic song that is best described as quirky and reflective. Guitar is the primary instrument in this track.",
                music_tags: ["quirky", "reflective", "guitar", "acoustic", "medium energy", "geo", "warsaw"],
                music_genre: ["Guitar", "Acoustic", "Geo Music"],
                music_mood: ["Romantic"],
                music_movement: [],
                 
              
                art_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT005.avif",
                art: "https://cdn-img.muzible.com/tracks/default/DEFAULT005_200x200.avif",
                src: "https://cdn.s0p.muzible.com/DEFAULT005/DEFAULT005_160kbps_preview.mp4",
                hlssrc: "",
              
                published: 1,
                stream_lvl: 0, // Poziom streama, 0 - darmowy (backup na lvl0 bucket), 1 - platny (backup na lvl1 bucket), 2 - platny Atmos (backup na lvl1 bucket)
                type: "geo", // muze, ticket, geo, global - informacje jak zostal dodany zasob i co zawiera (global to B2B streamy)
                playable: 1, // czy mozna odtworzyc 0 lub 1 - informacja dla playera - dodac mozan tylko utwory Playable. Domyslnie 1 dla muzyki.
                streamable: 0, // czy mozna streamowac 0 lub 1, inaczej albo owner albo creator albo sub(creatora) albo gerolokalizacyjny. Nie da sie zmienic ustawiany raz.
                public: 1, // czy jest publiczny 0 lub 1 - publiczy laduje w buckecie lvl0 oraz lvl0_flac i jest w jednej najlepszej wersji dostepny dla kazdego za darmo.
                // public owner zasobu moze zmienic z 0 na 1 lub z 1 na 0, wywoluje to przekodowanie muzyki i zmiane w bucketach (usuniecie starych i dodanie nowych lokalizacji,
                // podczas zmiany mozan podmienic jakosc utworu. Zmiany moze dokonac tylko creator zasobu i tylko dla obietkow ktore nie sa NFTkami lub Geo - czyli sa Streamowalne (NFT i GEO nie sa).
                stream_count: 0, // ile razy odtworzono, raz dziennie update licznikow
                creator: "Muzible", // tworca zasobu - nie mozan zmienic nigdy.
                creator_sub: 0, // czy creatora mozna subskrybowac 0 lub 1 - muzyka zaladowana ze B2B stream ma kreatora ogolnego, kreatorem moze byc tez Muzible, tacy kreatorzy nie sa subskrybowalni
                owner: "Muzible", // aktualny owner tego zasobu - wykorzystwane dla NFT, Lokalizacyjnych NFT, Ticketow. Takie zasoby sa zazwyczaj handlowalne.
                royalty_free: 1, // czy jest bezplatny jesli 1 to za streamowanie nikt nie placi, tzn ze jest darmowy i creator nie dostanie nic za odtworzenia. Glownie stosowane w NFT oraz publicznych zasobach (lvl0) (takze podcasty)
                stream_pps: 0, // level platnosci za streamowanie - 1 podstawowy, 2 - dla streamow Atmos - creatorzy atmos zarabiaja troche wiecej za odtworzenie.
                nft_is: 0, // jest nftkiem - moze byc NFTkiem streamable - wtedy owner aktualny zgarnia za streamy dzieli streamy (przychody) sie to na N ownerow i creatora.
                nft_totalsize: 0, // rozmiar dropa dla nft (-1) jesli unlimited - informacja o lacznym nakladzie danego NFT, jesli -1 to nie ma limitu 0 moze byc czasowy limit na claim NFT np geo/ticket.
                nft_number: 0, // numer nftka bue wuejszt niz nft_totalsize
                nft_start_price_usd: 0, // cena startowa nftka w usd ustawione na poziomie kolekcji badz osobno per NFT
                nft_start_price_muz: 0, // cena startowa nftka w muz ustawione na poziomie kolekcji badz osobno per NFT
                nft_merch: 0, // czy jest merch O lub 1 - wtedy mozab go uzyc w sklepie. Takie NFTki pojawia sie w Collections jako Merch
                nft_resale_to_creator_percent: 0, // % zysku dla tworcy przy kazdej odsprzedazy, standardowo 10% - mozna zmienic dla kazdego NFTka na od 0 do 50.
                nft_claim_end_time: "", // czas do kiedy mozna claimowac - glownie NFT lokalizacyjne i ticketowe (glownie takie unlimited ale nie musza byc unlimited)
                nft_bonus: 0, // czy jest bonusowy - jesli tak to dodatkowe bonusy dla ownera
                nft_bonus_type: "", // typ bonusu money - przypisane sa MUZy do tego NFTka - w czasie tworzenia przez artyste juz musza byc zdeponowane, podczas claimu/zmiany ownera pierwszy raz owner dostaje bonus
                // inne typy bonusow moga byc dodawane na biezaco i ich obsluga moze byc na poziomie pozniejszego mercha.
                nft_bonus_info: {}, // dodatkowe informacje o bonusie - np. ile MUZy, jakie prawa, jakie inne bonusy, jakie merch itp. info dla Engine bonusow
                nft_bonus_used: 0, // czy bonus juz byl uzyty - jesli tak to nie mozna go juz uzyc, moze zalezec od typu bonusa. Obsluga po stronie backendu tylko. (bonus engine)
                geo_link: "https://www.google.pl/maps/place/Spotify+Poland+Sp.+z+o.o./@52.2303358,21.003612,547m", // link do lokalizacji geo - zobacyzmy gdzie dokladnie - moze google maps czy cos innego..
                geo_time_until: "", // czas do kiedy jest widoczny w geolokacji, jesli pusty to widocznosc bez konca, jesli widocznosc minie to zasob zwraca src: domyslny dzwiek dla wszystkich niedostepnych.
                geo_location_lon: "21.002503526075333", // lokalizacja geograficzna
                geo_location_lat: "52.230821023094244", // lokalizacja geograficzna
                geo_location_radius: 20000, // promien lokalizacji we metrach na jaka odleglosc lapie lokalizacja
                // Geo powinna byc skanowalna albo nie skanowalna - wtedy wystarczy byc w lokalizacji (badz byc ownerem/creatorem),
                // Jak jest nie skanowalny GEO NFT to w lokalizacji mozna odtworzyc ale mozna tez kupic takiego NFT i odtwarzac poza lokalizacja.
                // Jesli skanowalna - trzeba najpierw sie przejsc do lokalizacji i tam zeskanowac i zclaimowac NFTka, wtedy jest juz odtwarzalny poza lokalizacja i mozna nim tez handlowac.
                // W obu przypoadkach, jesli ktos jest w lokalizacji to moze odtworzyc nawte jak nie ma NTka - chyba ze geo_time_until jest przekroczony - wtedy tylko owner/creator.
                // Jesli jest to GEO NFT - to obiekt GEO NFT
                geo_can_play_in_location_non_owner: 1, // czy nie bedac ownerem/creatorem mozna odtworzyc bedac w lokalizacji
                geo_nft_scan: 0, // czy jest skanowana i to wystarcza aby nabyc - trzeba przyjsc do lokalizacji zeskanow i wtedy mozan claimowac NFTka (jesli wciaz dostepny)
                geo_nft_buy: 0, // czy jest kupowalny i mozna kupic przed odtworzeniem - troche w ciemno zostac wlascicielem praw do zasobu (geo nie sa streamowalne!). Wciaz moze byc tak ze
                // po kupnie trzeba przejsc do lokalizacji zeby zeskanowac i zclaimowac NFTka, zasob GEO NFT  moze dawac prawa do odtworzenia muzyki poza lokalizacja, oraz inne dowolne, ale moze tez:
                // podczas Claimu w lokalizacji,
                geo_nfts: [], // jesli jest NFTkiem to lista NFTkow ktore sa wlasnoscia tego obiektu - mozna miec kilka NFTkow na jednym obiekcie
                // Te NFtki sa wczesniej stworzone przez tworce, moga byc playable i non playble, nie moga byc streamable. moga zawierac merch. kazdy GEO NFT ma swoj ID i moze miec przypisane dodatkowe unikatowe NFTki
                // GEO NFt szeruja naotmiast wspolne dane nie zmienialne, tak by czas, dostepnosc, ilosc, lokalizacja zawsze byly te same.
                // Beda w lokalizacji z obiektem geo_nft_scan : 1, pojawi sie lista NFTkow ktore mozna claimowac - nie widzimy co zawieraja (geo_nfts) ale widzimy ile jest NFTkow do claimowania i sami dokonujemy wyboru z dostepnych
                // Wtedy po claimowaniu dostajemy dostep do zasobu i mozemy go odtwarzac poza lokalizacja, ponadto stajemy sie tez ownerem geo_nfts - ktore UWAGA! - moga zawierac dodatki/bonusy(glownie non-playable).
                ai_gen: 0, // informacja czy zasob zostal wygenerowane przez AI (muze engine)
                ai_gen_prompt: "", // informacja jakie byly parametry generacji
                ai_gen_score: 0, // jakosc generacji - 0-100 - ocenia uzytkownik ktory generowal (raz)
                ai_gen_mood: 0, // informacja czy zostal wygenerowany na podstawie zdjecia (muze engine)
                ai_gen_mood_link: "", // link do zdjecia z ktorego generowano muzyke (w muze engine)
                // Lokalizacje plikow wszystkich leveli + lokalizacja oryginalu nie widoczne na zewnatrz - zapisane po skanowaniu i generacji plikow
                nv_link_flac: "",
                nv_link_atmos: "",
                nv_link_768: "",
                nv_link_320: "https://cdn.s0.muzible.com/DEFAULT005/DEFAULT005.mpd",
                nv_link_backup: "https://cdn.s0.muzible.com/DEFAULT005/DEFAULT005_160kbps_backup.mp4",
                nv_link_preview: "https://cdn.s0p.muzible.com/DEFAULT005/DEFAULT005_160kbps_preview.mp4",
                nv_link_raw_file: "s3://muzible-music-raw/stream-free/default_music/Dario_Benedetti_Soledad_instrumental_2_07.mp3",
                nv_link_creator: "https://cdn.c0.muzible.com/MUZIBLE/DEFAULT005.mpd",
                nv_has_flac: 0,
                nv_has_atmos: 0,
                nv_has_768: 0,
                nv_has_320: 1,
                nv_has_backup: 1,
                nv_has_preview: 1,
                nv_has_creator: 1, duration: "2:07",
              },
            ]
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.getPlaylistTracks(credentials)

        },

        getTrackById: ({ commit }, credentials) => {
          /*var data = {
            track:               {
                id: "DEFAULT001",
                timestamp: "2024-12-01 12:12:12",
                title: "Abstract Technology",
                artists_stream_w: [1], artists: ["NRA-LAB"],
                album: "",
                album_connected: [],
                channel_connected: [],
                explicit_text: 0, // czy jest tekst niecenzuralny/wykluczajacy
                publisher_timestamp: "2024-11-12 12:12:12", // czas publikacji zasobu
                publisher_info: "2024 Muzible", // wydawca zasobu
                similar_songs: [],
                excluded_countries: [],
                description: "Invitation, Unstoppable, Journey music.",
                music_tags: ["magnetic", "emotional", "piano", "sci fi", "india", "krishna", "journey"],
                music_genre: ["Future Bass", "Beats", "Electronic", "Corporate"],
                music_mood: ["Dreamy", "Hopeful", "Bright", "Uplifting"],
                music_movement: ["Floating", "Smooth", "Chasing", "Medium", "Elegant"],
                
                art_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT001.webp",
                art: "https://cdn-img.muzible.com/tracks/default/DEFAULT001_200x200.webp",
                src: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001_160kbps_backup.mp4",
                hlssrc: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001.mpd",
                
                published: 1,
                stream_lvl: 0, // Poziom streama, 0 - darmowy (backup na lvl0 bucket), 1 - platny (backup na lvl1 bucket), 2 - platny Atmos (backup na lvl1 bucket)
                type: "muze", // muze, ticket, geo, global, podcast - informacje jak zostal dodany zasob i co zawiera (global to B2B streamy)
                playable: 1, // czy mozna odtworzyc 0 lub 1 - informacja dla playera - dodac mozan tylko utwory Playable. Domyslnie 1 dla muzyki.
                streamable: 1, // czy mozna streamowac 0 lub 1, inaczej albo owner albo creator albo sub(creatora) albo gerolokalizacyjny. Nie da sie zmienic ustawiany raz.
                public: 1, // czy jest publiczny 0 lub 1 - publiczy laduje w buckecie lvl0 oraz lvl0_flac i jest w jednej najlepszej wersji dostepny dla kazdego za darmo.
                // public owner zasobu moze zmienic z 0 na 1 lub z 1 na 0, wywoluje to przekodowanie muzyki i zmiane w bucketach (usuniecie starych i dodanie nowych lokalizacji,
                // podczas zmiany mozan podmienic jakosc utworu. Zmiany moze dokonac tylko creator zasobu i tylko dla obietkow ktore nie sa NFTkami lub Geo - czyli sa Streamowalne (NFT i GEO nie sa).
                stream_count: 0, // ile razy odtworzono, raz dziennie update licznikow
                creator: "Muzible", // tworca zasobu - nie mozan zmienic nigdy.
                creator_sub: 0, // czy creatora mozna subskrybowac 0 lub 1 - muzyka zaladowana ze B2B stream ma kreatora ogolnego, kreatorem moze byc tez Muzible, tacy kreatorzy nie sa subskrybowalni
                owner: "Muzible", // aktualny owner tego zasobu - wykorzystwane dla NFT, Lokalizacyjnych NFT, Ticketow. Takie zasoby sa zazwyczaj handlowalne.
                royalty_free: 1, // czy jest bezplatny jesli 1 to za streamowanie nikt nie placi, tzn ze jest darmowy i creator nie dostanie nic za odtworzenia. Glownie stosowane w NFT oraz publicznych zasobach (lvl0) (takze podcasty)
                stream_pps: 0, // level platnosci za streamowanie - 1 podstawowy, 2 - dla streamow Atmos - creatorzy atmos zarabiaja troche wiecej za odtworzenie.
                nft_is: 0, // jest nftkiem - moze byc NFTkiem streamable - wtedy owner aktualny zgarnia za streamy dzieli streamy (przychody) sie to na N ownerow i creatora.
                nft_totalsize: 0, // rozmiar dropa dla nft (-1) jesli unlimited - informacja o lacznym nakladzie danego NFT, jesli -1 to nie ma limitu 0 moze byc czasowy limit na claim NFT np geo/ticket.
                nft_number: 0, // numer nftka bue wuejszt niz nft_totalsize
                nft_start_price_usd: 0, // cena startowa nftka w usd ustawione na poziomie kolekcji badz osobno per NFT
                nft_start_price_muz: 0, // cena startowa nftka w muz ustawione na poziomie kolekcji badz osobno per NFT
                nft_merch: 0, // czy jest merch O lub 1 - wtedy mozab go uzyc w sklepie. Takie NFTki pojawia sie w Collections jako Merch
                nft_resale_to_creator_percent: 0, // % zysku dla tworcy przy kazdej odsprzedazy, standardowo 10% - mozna zmienic dla kazdego NFTka na od 0 do 50.
                nft_claim_end_time: "", // czas do kiedy mozna claimowac - glownie NFT lokalizacyjne i ticketowe (glownie takie unlimited ale nie musza byc unlimited)
                nft_bonus: 0, // czy jest bonusowy - jesli tak to dodatkowe bonusy dla ownera
                nft_bonus_type: "", // typ bonusu money - przypisane sa MUZy do tego NFTka - w czasie tworzenia przez artyste juz musza byc zdeponowane, podczas claimu/zmiany ownera pierwszy raz owner dostaje bonus
                // inne typy bonusow moga byc dodawane na biezaco i ich obsluga moze byc na poziomie pozniejszego mercha.
                nft_bonus_info: {}, // dodatkowe informacje o bonusie - np. ile MUZy, jakie prawa, jakie inne bonusy, jakie merch itp. info dla Engine bonusow
                nft_bonus_used: 0, // czy bonus juz byl uzyty - jesli tak to nie mozna go juz uzyc, moze zalezec od typu bonusa. Obsluga po stronie backendu tylko. (bonus engine)
                geo_link: "", // link do lokalizacji geo - zobacyzmy gdzie dokladnie - moze google maps czy cos innego..
                geo_time_until: "", // czas do kiedy jest widoczny w geolokacji, jesli pusty to widocznosc bez konca, jesli widocznosc minie to zasob zwraca src: domyslny dzwiek dla wszystkich niedostepnych.
                geo_location_lon: "", // lokalizacja geograficzna
                geo_location_lat: "", // lokalizacja geograficzna
                geo_location_radius: 0, // promien lokalizacji we metrach na jaka odleglosc lapie lokalizacja
                // Geo powinna byc skanowalna albo nie skanowalna - wtedy wystarczy byc w lokalizacji (badz byc ownerem/creatorem),
                // Jak jest nie skanowalny GEO NFT to w lokalizacji mozna odtworzyc ale mozna tez kupic takiego NFT i odtwarzac poza lokalizacja.
                // Jesli skanowalna - trzeba najpierw sie przejsc do lokalizacji i tam zeskanowac i zclaimowac NFTka, wtedy jest juz odtwarzalny poza lokalizacja i mozna nim tez handlowac.
                // W obu przypoadkach, jesli ktos jest w lokalizacji to moze odtworzyc nawte jak nie ma NTka - chyba ze geo_time_until jest przekroczony - wtedy tylko owner/creator.
                // Jesli jest to GEO NFT - to obiekt GEO NFT
                geo_can_play_in_location_non_owner: 1, // czy nie bedac ownerem/creatorem mozna odtworzyc bedac w lokalizacji
                geo_nft_scan: 0, // czy jest skanowana i to wystarcza aby nabyc - trzeba przyjsc do lokalizacji zeskanow i wtedy mozan claimowac NFTka (jesli wciaz dostepny)
                geo_nft_buy: 0, // czy jest kupowalny i mozna kupic przed odtworzeniem - troche w ciemno zostac wlascicielem praw do zasobu (geo nie sa streamowalne!). Wciaz moze byc tak ze
                // po kupnie trzeba przejsc do lokalizacji zeby zeskanowac i zclaimowac NFTka, zasob GEO NFT  moze dawac prawa do odtworzenia muzyki poza lokalizacja, oraz inne dowolne, ale moze tez:
                // podczas Claimu w lokalizacji,
                geo_nfts: [], // jesli jest NFTkiem to lista NFTkow ktore sa wlasnoscia tego obiektu - mozna miec kilka NFTkow na jednym obiekcie
                // Te NFtki sa wczesniej stworzone przez tworce, moga byc playable i non playble, nie moga byc streamable. moga zawierac merch. kazdy GEO NFT ma swoj ID i moze miec przypisane dodatkowe unikatowe NFTki
                // GEO NFt szeruja naotmiast wspolne dane nie zmienialne, tak by czas, dostepnosc, ilosc, lokalizacja zawsze byly te same.
                // Beda w lokalizacji z obiektem geo_nft_scan : 1, pojawi sie lista NFTkow ktore mozna claimowac - nie widzimy co zawieraja (geo_nfts) ale widzimy ile jest NFTkow do claimowania i sami dokonujemy wyboru z dostepnych
                // Wtedy po claimowaniu dostajemy dostep do zasobu i mozemy go odtwarzac poza lokalizacja, ponadto stajemy sie tez ownerem geo_nfts - ktore UWAGA! - moga zawierac dodatki/bonusy(glownie non-playable).
                ai_gen: 0, // informacja czy zasob zostal wygenerowane przez AI (muze engine)
                ai_gen_prompt: "", // informacja jakie byly parametry generacji
                ai_gen_score: 0, // jakosc generacji - 0-100 - ocenia uzytkownik ktory generowal (raz)
                ai_gen_mood: 0, // informacja czy zostal wygenerowany na podstawie zdjecia (muze engine)
                ai_gen_mood_link: "", // link do zdjecia z ktorego generowano muzyke (w muze engine)
                // Lokalizacje plikow wszystkich leveli + lokalizacja oryginalu nie widoczne na zewnatrz - zapisane po skanowaniu i generacji plikow
                nv_link_flac: "",
                nv_link_atmos: "",
                nv_link_768: "",
                nv_link_320: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001.mpd",
                nv_link_backup: "https://cdn.s0.muzible.com/DEFAULT001/DEFAULT001_160kbps_backup.mp4",
                nv_link_preview: "https://cdn.s0p.muzible.com/DEFAULT001/DEFAULT001_160kbps_preview.mp4",
                nv_link_raw_file: "s3://muzible-music-raw/stream-free/default_music/abstract-technology-pixelated-futures-230634.mp3",
                nv_link_creator: "https://cdn.c0.muzible.com/MUZIBLE/DEFAULT001.mpd",
                nv_has_flac: 0,
                nv_has_atmos: 0,
                nv_has_768: 0,
                nv_has_320: 1,
                nv_has_backup: 1,
                nv_has_preview: 1,
                nv_has_creator: 1, duration: "2:24",
              },
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.getTrackById(credentials)

        },


        async getTickets({ commit }, credentials) {
         /* var data = {
            //tickets: []
            tickets: [
              {
                // === PODSTAWOWE INFO ===
                id: "TICKET001", // Unikalny ID biletu
                ticket_number: "2024-EVT001-0001", // Numer biletu (human-readable)
                event_id: "EVENT008", // ID wydarzenia
                event_name: "Muzible Hip Hop Festival 2024", // Nazwa wydarzenia
                event_description: "The biggest music festival of the year featuring 50+ artists", // Opis wydarzenia
                event_location: "National Stadium, Warsaw", // Miejsce wydarzenia
                event_location_address: "Poniatowskiego 1, 00-001 Warsaw, Poland", // Adres
                event_location_gps: {
                  lat: "52.2394845",
                  lon: "21.0458205"
                },
                event_location_map_link: "https://maps.google.com/?q=52.2394845,21.0458205", // Link do mapy
                event_date: "2025-11-17", // Data wydarzenia (YYYY-MM-DD)
                event_time_start: "18:00", // Czas rozpoczęcia
                event_time_end: "2027-11-18 23:59:00", // Czas zakończenia (pełny timestamp)
                event_timezone: "Europe/Warsaw", // Strefa czasowa

                // === INFO O BILECIE ===
                ticket_type: "VIP", // Typ: VIP, Standard, Early Bird, Premium, etc.
                ticket_category: "standing", // Kategoria: standing, seated, vip_lounge
                ticket_section: "A", // Sektor (jeśli applicable)
                ticket_row: "12", // Rząd (jeśli seated)
                ticket_seat: "45", // Miejsce (jeśli seated)
                ticket_description: "Full access VIP ticket with backstage pass and meet & greet", // Opis biletu
                ticket_valid_from: "2025-11-18 16:00:00", // Od kiedy ważny do uzycia (online/perki itd.)
                ticket_valid_until: "2026-11-19 02:00:00", // Do kiedy ważny do uzycia 
                
                // === WŁAŚCICIEL ===
                owner_id: "160nahwyn4", // ID aktualnego właściciela (user ID)
                owner_email: "tomasz.andel@gmail.com", // Email właściciela
                owner_name: "Tomasz", // Imię i nazwisko (jeśli non-transferable ticket)
                owner_surname: "Andel", // Nazwisko (jeśli non-transferable ticket)
                owner_verse_username: "",
                owner_history: [ // Historia właścicieli (dla NFT)
                  {
                    owner_id: "160nahwyn4",
                    owner_email: "tomasz.andel@gmail.com",
                    owner_verse_username: "",
                    acquired_date: "2024-01-15 12:30:00",
                    acquired_price_usd: 150,
                    acquired_price_muz: 0,
                    acquired_price_eur: 0,
                    acquired_price_pln: 0,
                    acquired_price_btc: 0,
                    acquired_price_eth: 0,
                    acquired_method: "purchase" // purchase, transfer, claim, airdrop
                  }
                ],

                // === ORGANIZATOR ===
                issuer_id: "ORG001", // ID organizatora
                issuer_name: "Muzible Events", // Nazwa organizatora
                issuer_email: "events@muzible.com", // Email organizatora
                issuer_verified: 1, // Czy zweryfikowany organizator
                issue_date: "2024-01-15 12:30:00", // Data wystawienia biletu
                issue_timestamp: "2024-01-15T12:30:00.000Z", // Timestamp wystawienia

                // === CENA & PŁATNOŚĆ ===
                price_paid_usd: 150, // Cena zapłacona w USD
                price_paid_eur: 0, // Cena zapłacona w EUR
                price_paid_pln: 0, // Cena zapłacona w PLN
                price_paid_muz: 0, // Cena zapłacona w MUZ
                price_paid_eth: 0, // Cena zapłacona w ETH
                price_paid_btc: 0, // Cena zapłacona w BTC
                payment_method: "stripe", // Metoda płatności: stripe, paypal, metamask, crypto
                payment_transaction_id: "pi_3KxJ....", // ID transakcji płatności
                payment_date: "2024-01-15 12:30:00", // Data płatności

                // === NFT INFO ===
                is_nft: 1, // Czy jest NFT (1) czy zwykłym biletem (0)
                is_transferable: 0, // Czy można przenieść (1) czy jest personalizowany (0)
                transfer_count: 0, // Ile razy został przeniesiony
                transfer_max: 0, // Maksymalna liczba transferów (-1 = unlimited)
                is_resellable: 1, // Czy można wystawić na sprzedaż
                is_listed_for_sale: 0, // Czy wysatwione aktualnie na sprzedaz
                resale_royalty_percent: 10, // Procent dla organizatora przy odsprzedaży
                resale_current_price_usd: 0, // Aktualna cena na sprzedaż (0 = nie na sprzedaż)
                resale_current_price_muz: 290, // Aktualna cena w MUZ
                resale_current_price_eur: 0,
                resale_current_price_pln: 0,
                resale_current_price_btc: 0,
                resale_current_price_eth: 0,
                resale_history: [ // Historia cen sprzedaży
                  {
                    price_usd: 200,
                    price_muz: 0,
                    price_eur: 0,
                    price_pln: 0,
                    price_btc: 0,
                    price_eth: 0,
                    listed_date: "2024-02-01",
                    withdraw_date: "",
                    sold: 1,
                    sold_date: "2024-02-10"
                  },
                  {
                    price_usd: 0,
                    price_muz: 290,
                    price_eur: 0,
                    price_pln: 0,
                    price_btc: 0,
                    price_eth: 0,
                    listed_date: "2024-02-01",
                    withdraw_date: "2024-02-02",
                    sold: 0,
                    sold_date: ""
                  }
                ],
                
                // === BLOCKCHAIN (jeśli NFT) ===
                blockchain_chain: "polygon", // Chain: polygon, ethereum, base
                blockchain_contract: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb", // Adres smart contract
                blockchain_token_id: "1234567890", // Token ID na blockchainie
                blockchain_tx_hash: "0x9fc76417374aa880d4449a1f7f31ec597f00b1f6f3dd2d66f4c9c6c445836d8b", // Hash transakcji mint
                blockchain_owner_address: "0x71ce6f682075458492c4ed33c6f2705BC83E2AD7", // Adres walleta właściciela
                blockchain_metadata_uri: "ipfs://QmZ4tDuvesekSs4qM5ZBKpXiZGun7S2CYtEZRB3DYXkjGx", // URI do metadanych NFT

                // === WALIDACJA & STATUS ===
                status: "active", // Status: active, used, cancelled, refunded, expired
                is_used: 1, // Czy został użyty
                used_date: "2024-08-15 18:15:00", // Data użycia ostaniego
                used_by: "STAFF001", // Kto zwalidował (ID pracownika) ostatnio
                validation_count: 3, // Ile razy zwalidowany (może być wielokrotny wstęp)
                validation_max: 5, // Maksymalna liczba walidacji
                validation_history: [ // Historia walidacji
                  {
                    validated_date: "2024-08-15 18:15:00",
                    validated_by: "STAFF001",
                    validated_location: "Gate A",
                    validation_type: "entry" // entry, exit, re-entry
                  },
                  {
                    validated_date: "2024-08-16 18:15:00",
                    validated_by: "STAFF001",
                    validated_location: "Gate A",
                    validation_type: "re-entry" // entry, exit, re-entry
                  },
                  {
                    validated_date: "2024-08-16 18:15:00",
                    validated_by: "STAFF001",
                    validated_location: "Bar Area",
                    validation_type: "perk" // entry, exit, re-entry
                  }
                ],
                is_cancelled: 0, // Czy anulowany
                cancelled_date: "", // Data anulowania
                cancelled_reason: "", // Powód anulowania
                is_refunded: 0, // Czy zwrócono pieniądze
                refund_date: "", // Data zwrotu
                refund_requested: 0, // Czy zwrot został zgłoszony
                refund_rejected: 0, // Czy wniosek o zwrot został odrzucony
                refund_rejected_reason: "", // Powód odrzucenia zwrotu
                refund_amount: 0, // Kwota zwrotu
                refund_policy: "refundable_until_event", // Polityka zwrotów: non_refundable, refundable_until_event

                // === QR CODE & SECURITY ===
                qr_code: "MUZIBLE-TICKET-2024-EVT001-0001-SECURE-HASH-12345", // Kod do generowania QR
                // qr_code_hash: "sha256:a3d8f7e2...", // Hash QR kodu (dla bezpieczeństwa) - tylko dla backendu!
                security_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // JWT token do walidacji
                encryption_enabled: 1, // Czy QR jest szyfrowany

                // === DODATKI & UPRAWNIENIA ===
                perks: [ // Lista dodatkowych uprawnień
                  {
                    perk_id: "PERK001",
                    perk_type: "backstage_pass", // backstage_pass, meet_greet, free_drink, parking, merch_discount
                    perk_name: "Backstage Pass",
                    perk_description: "Access to backstage area after main show",
                    perk_used: 1,
                    perk_used_date: "2024-08-15 23:00:00",
                    perk_valid_from: "2024-08-15 22:00:00",
                    perk_valid_until: "2024-08-16 01:00:00"
                  },
                  {
                    perk_id: "PERK002",
                    perk_type: "meet_greet",
                    perk_name: "Meet & Greet",
                    perk_description: "Meet the artists after the show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:30:00",
                    perk_valid_until: "2024-08-15 23:30:00"
                  },
                  {
                    perk_id: "PERK003",
                    perk_type: "free_drink",
                    perk_name: "2 Free Drinks",
                    perk_description: "2 complimentary drinks at VIP bar",
                    perk_quantity: 2,
                    perk_quantity_used: 0,
                    perk_used: 0
                  }
                ],

                // === MEDIA ===
                // Docelowe linki
                //image_full: "https://cdn-img.muzible.com/tickets/TICKET001/full.webp", // Pełny obraz biletu
                //event_image: "https://cdn-img.muzible.com/events/EVENT001/poster.webp", // Plakat wydarzenia

                image_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT008.webp", // Pełny obraz biletu
                event_image: "https://cdn-img.muzible.com/tracks/default/DEFAULT011.webp", // Plakat wydarzenia

                // === PROMOCYJNY UTWÓR ===
                promo_track_id: "DEFAULT001", // ID utworu promocyjnego (pobierany z API)
                promo_track_unlocked: 1, // Czy odblokowany (może być bonus za zakup)
                promo_track_playable: 1, // Czy można odtworzyć

                // === METADANE ===
                created_at: "2024-01-15 12:30:00",
                updated_at: "2024-01-15 12:30:00",
                version: 1, // Wersja struktury (na przyszłość)
                notes: "", // Dodatkowe notatki (dla admina/organizatora)
                tags: ["vip", "festival", "summer", "2024"], // Tagi dla łatwiejszego wyszukiwania
                
                // === INNE ===
                language: ["en","pl","fr"], // Język biletu
                terms_url: "https://tickets.muzible.com/events/eventid/terms", // Link do regulaminu
                privacy_url: "https://tickets.muzible.com/events/eventid/privacy", // Link do polityki prywatności
              },
                            {
                // === PODSTAWOWE INFO ===
                id: "TICKET001", // Unikalny ID biletu
                ticket_number: "2024-EVT001-0001", // Numer biletu (human-readable)
                event_id: "EVENT001", // ID wydarzenia
                event_name: "Muzible Live Festival 2024", // Nazwa wydarzenia
                event_description: "The biggest music festival of the year featuring 50+ artists", // Opis wydarzenia
                event_location: "National Stadium, Warsaw", // Miejsce wydarzenia
                event_location_address: "Poniatowskiego 1, 00-001 Warsaw, Poland", // Adres
                event_location_gps: {
                  lat: "52.2394845",
                  lon: "21.0458205"
                },
                event_location_map_link: "https://maps.google.com/?q=52.2394845,21.0458205", // Link do mapy
                event_date: "2026-08-15", // Data wydarzenia (YYYY-MM-DD)
                event_time_start: "18:00", // Czas rozpoczęcia
                event_time_end: "23:59", // Czas zakończenia
                event_timezone: "Europe/Warsaw", // Strefa czasowa

                // === INFO O BILECIE ===
                ticket_type: "VIP", // Typ: VIP, Standard, Early Bird, Premium, etc.
                ticket_category: "standing", // Kategoria: standing, seated, vip_lounge
                ticket_section: "A", // Sektor (jeśli applicable)
                ticket_row: "12", // Rząd (jeśli seated)
                ticket_seat: "45", // Miejsce (jeśli seated)
                ticket_description: "Full access VIP ticket with backstage pass and meet & greet", // Opis biletu
                ticket_valid_from: "2024-08-15 16:00:00", // Od kiedy ważny
                ticket_valid_until: "2024-08-16 02:00:00", // Do kiedy ważny
                
                // === WŁAŚCICIEL ===
                owner_id: "160nahwyn4", // ID aktualnego właściciela (user ID)
                owner_email: "tomasz.andel@gmail.com", // Email właściciela
                owner_verse_username: "Andel_Tomasz",
                owner_name: "", // Imię i nazwisko (jeśli non-transferable ticket)
                owner_surname: "", // Nazwisko (jeśli non-transferable ticket)
                owner_history: [ // Historia właścicieli (dla NFT)
                  {
                    owner_id: "160nahwyn4",
                    owner_email: "tomasz.andel@gmail.com",
                    owner_verse_username: "Andel_Tomasz",
                    acquired_date: "2024-01-15 12:30:00",
                    acquired_price_usd: 150,
                    acquired_price_muz: 0,
                    acquired_method: "purchase" // purchase, transfer, claim, airdrop
                  },
                  {
                    owner_id: "160nahwyn4",
                    owner_email: "tomasz.andel_2@gmail.com",
                    owner_verse_username: "Andel_Tomasz_2",
                    acquired_date: "2024-01-16 12:30:00",
                    acquired_price_usd: 250,
                    acquired_price_muz: 0,
                    acquired_method: "purchase" // purchase, transfer, claim, airdrop
                  }
                ],

                // === ORGANIZATOR ===
                issuer_id: "ORG001", // ID organizatora
                issuer_name: "Muzible Events", // Nazwa organizatora
                issuer_email: "events@muzible.com", // Email organizatora
                issuer_verified: 1, // Czy zweryfikowany organizator
                issue_date: "2024-01-15 12:30:00", // Data wystawienia biletu
                issue_timestamp: "2024-01-15T12:30:00.000Z", // Timestamp wystawienia

                // === CENA & PŁATNOŚĆ ===
                price_paid_usd: 150, // Cena zapłacona w USD
                price_paid_eur: 0, // Cena zapłacona w EUR
                price_paid_pln: 0, // Cena zapłacona w PLN
                price_paid_muz: 0, // Cena zapłacona w MUZ
                price_paid_eth: 0, // Cena zapłacona w ETH
                price_paid_btc: 0, // Cena zapłacona w BTC
                price_original_usd: 150, // Oryginalna cena (mogła być promocja)
                payment_currency: "USD", // W jakiej walucie zapłacono
                payment_method: "stripe", // Metoda płatności: stripe, paypal, metamask, crypto
                payment_transaction_id: "pi_3KxJ....", // ID transakcji płatności
                payment_date: "2024-01-15 12:30:00", // Data płatności

                // === NFT INFO ===
                is_nft: 1, // Czy jest NFT (1) czy zwykłym biletem (0)
                is_transferable: 1, // Czy można przenieść (1) czy jest personalizowany (0)
                transfer_count: 0, // Ile razy został przeniesiony
                transfer_max: 3, // Maksymalna liczba transferów (-1 = unlimited)
                is_resellable: 1, // Czy można wystawić na sprzedaż
                is_listed_for_sale: 0, // Czy wysatwione aktualnie na sprzedaz
                resale_royalty_percent: 10, // Procent dla organizatora przy odsprzedaży
                resale_current_price_usd: 0, // Aktualna cena na sprzedaż (0 = nie na sprzedaż)
                resale_current_price_muz: 0, // Aktualna cena w MUZ
                resale_current_price_eur: 0,
                resale_current_price_pln: 0,
                resale_current_price_btc: 0,
                resale_current_price_eth: 0,
                resale_history: [ // Historia cen sprzedaży

                ],
                
                // === BLOCKCHAIN (jeśli NFT) ===
                blockchain_chain: "polygon", // Chain: polygon, ethereum, base
                blockchain_contract: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb", // Adres smart contract
                blockchain_token_id: "1234567890", // Token ID na blockchainie
                blockchain_tx_hash: "0x9fc76417374aa880d4449a1f7f31ec597f00b1f6f3dd2d66f4c9c6c445836d8b", // Hash transakcji mint
                blockchain_owner_address: "0x71ce6f682075458492c4ed33c6f2705BC83E2AD7", // Adres walleta właściciela
                blockchain_metadata_uri: "ipfs://QmZ4tDuvesekSs4qM5ZBKpXiZGun7S2CYtEZRB3DYXkjGx", // URI do metadanych NFT

                // === WALIDACJA & STATUS ===
                status: "active", // Status: active, used, cancelled, refunded, expired
                is_used: 0, // Czy został użyty
                used_date: "", // Data użycia
                used_by: "", // Kto zwalidował (ID pracownika)
                validation_count: 0, // Ile razy zwalidowany (może być wielokrotny wstęp)
                validation_max: 1, // Maksymalna liczba walidacji
                validation_history: [ // Historia walidacji
                  {
                    validated_date: "2024-08-15 18:15:00",
                    validated_by: "STAFF001",
                    validated_location: "Gate A",
                    validation_type: "entry" // entry, exit, re-entry
                  }
                ],
                is_cancelled: 0, // Czy anulowany
                cancelled_date: "", // Data anulowania
                cancelled_reason: "", // Powód anulowania
                is_refunded: 0, // Czy zwrócono pieniądze
                refund_date: "", // Data zwrotu
                                refund_requested: 0, // Czy zwrot został zgłoszony
                refund_rejected: 0, // Czy wniosek o zwrot został odrzucony
                refund_rejected_reason: "", // Powód odrzucenia zwrotu
                refund_amount: 0, // Kwota zwrotu
                refund_policy: "refundable_until_event", // Polityka zwrotów: refundable_30_days, non_refundable, refundable_until_event

                // === QR CODE & SECURITY ===
                qr_code: "MUZIBLE-TICKET-2024-EVT001-0001-SECURE-HASH-12345", // Kod do generowania QR
                qr_code_hash: "sha256:a3d8f7e2...", // Hash QR kodu (dla bezpieczeństwa)
                security_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // JWT token do walidacji
                encryption_enabled: 1, // Czy QR jest szyfrowany

                // === DODATKI & UPRAWNIENIA ===
                perks: [ // Lista dodatkowych uprawnień
                  {
                    perk_id: "PERK001",
                    perk_type: "backstage_pass", // backstage_pass, meet_greet, free_drink, parking, merch_discount
                    perk_name: "Backstage Pass",
                    perk_description: "Access to backstage area after main show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:00:00",
                    perk_valid_until: "2024-08-16 01:00:00"
                  },
                  {
                    perk_id: "PERK002",
                    perk_type: "meet_greet",
                    perk_name: "Meet & Greet",
                    perk_description: "Meet the artists after the show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:30:00",
                    perk_valid_until: "2024-08-15 23:30:00"
                  },
                  {
                    perk_id: "PERK003",
                    perk_type: "free_drink",
                    perk_name: "2 Free Drinks",
                    perk_description: "2 complimentary drinks at VIP bar",
                    perk_quantity: 2,
                    perk_quantity_used: 0,
                    perk_used: 0
                  }
                ],

                // === MEDIA ===
                // Docelowe linki
                //image_full: "https://cdn-img.muzible.com/tickets/TICKET001/full.webp", // Pełny obraz biletu
                //image_thumb: "https://cdn-img.muzible.com/tickets/TICKET001/thumb_200x200.webp", // Miniatura
                //image_qr: "https://cdn-img.muzible.com/tickets/TICKET001/qr.webp", // Wygenerowany QR kod (opcjonalnie)
                //event_image: "https://cdn-img.muzible.com/events/EVENT001/poster.webp", // Plakat wydarzenia

                image_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT008.webp", // Pełny obraz biletu
                image_thumb: "https://cdn-img.muzible.com/tracks/default/DEFAULT008_200x200.webp", // Miniatura
                image_qr: "https://cdn-img.muzible.com/tracks/default/DEFAULT012_200x200.jpg", // Wygenerowany QR kod (opcjonalnie)
                event_image: "https://cdn-img.muzible.com/tracks/default/DEFAULT011.webp", // Plakat wydarzenia

                // === PROMOCYJNY UTWÓR ===
                promo_track_id: "DEFAULT001", // ID utworu promocyjnego (pobierany z API)
                promo_track_unlocked: 1, // Czy odblokowany (może być bonus za zakup)
                promo_track_playable: 1, // Czy można odtworzyć

                // === METADANE ===
                created_at: "2024-01-15 12:30:00",
                updated_at: "2024-01-15 12:30:00",
                version: 1, // Wersja struktury (na przyszłość)
                notes: "", // Dodatkowe notatki (dla admina/organizatora)
                tags: ["vip", "festival", "summer", "2024"], // Tagi dla łatwiejszego wyszukiwania
                
                // === INNE ===
                language: "en", // Język biletu
                terms_url: "https://muzible.com/terms", // Link do regulaminu
                privacy_url: "https://muzible.com/privacy", // Link do polityki prywatności
              },
                            {
                // === PODSTAWOWE INFO ===
                id: "TICKET001", // Unikalny ID biletu
                ticket_number: "2025-EVT001-0001", // Numer biletu (human-readable)
                event_id: "EVENT011", // ID wydarzenia
                event_name: "Muzible Hip Hop Festival 2025", // Nazwa wydarzenia
                event_description: "The biggest music festival of the year featuring 50+ artists", // Opis wydarzenia
                event_location: "National Stadium, Warsaw", // Miejsce wydarzenia
                event_location_address: "Poniatowskiego 1, 00-001 Warsaw, Poland", // Adres
                event_location_gps: {
                  lat: "52.2394845",
                  lon: "21.0458205"
                },
                event_location_map_link: "https://maps.google.com/?q=52.2394845,21.0458205", // Link do mapy
                event_date: "2024-08-15", // Data wydarzenia (YYYY-MM-DD)
                event_time_start: "18:00", // Czas rozpoczęcia
                event_time_end: "23:59", // Czas zakończenia
                event_timezone: "Europe/Warsaw", // Strefa czasowa

                // === INFO O BILECIE ===
                ticket_type: "VIP", // Typ: VIP, Standard, Early Bird, Premium, etc.
                ticket_category: "standing", // Kategoria: standing, seated, vip_lounge
                ticket_section: "A", // Sektor (jeśli applicable)
                ticket_row: "12", // Rząd (jeśli seated)
                ticket_seat: "45", // Miejsce (jeśli seated)
                ticket_description: "Full access VIP ticket with backstage pass and meet & greet", // Opis biletu
                ticket_valid_from: "2024-08-15 16:00:00", // Od kiedy ważny
                ticket_valid_until: "2024-08-16 02:00:00", // Do kiedy ważny
                
                // === WŁAŚCICIEL ===
                owner_id: "160nahwyn4", // ID aktualnego właściciela (user ID)
                owner_email: "tomasz.andel@gmail.com", // Email właściciela
                owner_verse_username: "Andel_Tomasz",
                owner_name: "", // Imię i nazwisko (jeśli non-transferable ticket)
                owner_surname: "", // Nazwisko (jeśli non-transferable ticket)
                owner_history: [ // Historia właścicieli (dla NFT)
                  {
                    owner_id: "160nahwyn4",
                    owner_email: "tomasz.andel@gmail.com",
                    owner_verse_username: "Andel_Tomasz",
                    acquired_date: "2024-01-15 12:30:00",
                    acquired_price_usd: 150,
                    acquired_price_muz: 0,
                    acquired_method: "purchase" // purchase, transfer, claim, airdrop
                  }
                ],

                // === ORGANIZATOR ===
                issuer_id: "ORG001", // ID organizatora
                issuer_name: "Muzible Events", // Nazwa organizatora
                issuer_email: "events@muzible.com", // Email organizatora
                issuer_verified: 1, // Czy zweryfikowany organizator
                issue_date: "2024-01-15 12:30:00", // Data wystawienia biletu
                issue_timestamp: "2024-01-15T12:30:00.000Z", // Timestamp wystawienia

                // === CENA & PŁATNOŚĆ ===
                price_paid_usd: 150, // Cena zapłacona w USD
                price_paid_eur: 0, // Cena zapłacona w EUR
                price_paid_pln: 0, // Cena zapłacona w PLN
                price_paid_muz: 0, // Cena zapłacona w MUZ
                price_paid_eth: 0, // Cena zapłacona w ETH
                price_paid_btc: 0, // Cena zapłacona w BTC
                price_original_usd: 150, // Oryginalna cena (mogła być promocja)
                payment_currency: "USD", // W jakiej walucie zapłacono
                payment_method: "stripe", // Metoda płatności: stripe, paypal, metamask, crypto
                payment_transaction_id: "pi_3KxJ....", // ID transakcji płatności
                payment_date: "2024-01-15 12:30:00", // Data płatności

                // === NFT INFO ===
                is_nft: 1, // Czy jest NFT (1) czy zwykłym biletem (0)
                is_transferable: 1, // Czy można przenieść (1) czy jest personalizowany (0)
                transfer_count: 0, // Ile razy został przeniesiony
                transfer_max: 3, // Maksymalna liczba transferów (-1 = unlimited)
                is_resellable: 1, // Czy można wystawić na sprzedaż
                is_listed_for_sale: 0, // Czy wysatwione aktualnie na sprzedaz
                resale_royalty_percent: 10, // Procent dla organizatora przy odsprzedaży
                resale_current_price_usd: 0, // Aktualna cena na sprzedaż (0 = nie na sprzedaż)
                resale_current_price_muz: 0, // Aktualna cena w MUZ
                resale_current_price_eur: 0,
                resale_current_price_pln: 0,
                resale_current_price_btc: 0,
                resale_current_price_eth: 0,
                resale_history: [ // Historia cen sprzedaży
                ],
                
                // === BLOCKCHAIN (jeśli NFT) ===
                blockchain_chain: "polygon", // Chain: polygon, ethereum, base
                blockchain_contract: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb", // Adres smart contract
                blockchain_token_id: "1234567890", // Token ID na blockchainie
                blockchain_tx_hash: "0x9fc76417374aa880d4449a1f7f31ec597f00b1f6f3dd2d66f4c9c6c445836d8b", // Hash transakcji mint
                blockchain_owner_address: "0x71ce6f682075458492c4ed33c6f2705BC83E2AD7", // Adres walleta właściciela
                blockchain_metadata_uri: "ipfs://QmZ4tDuvesekSs4qM5ZBKpXiZGun7S2CYtEZRB3DYXkjGx", // URI do metadanych NFT

                // === WALIDACJA & STATUS ===
                status: "active", // Status: active, used, cancelled, refunded, expired
                is_used: 0, // Czy został użyty
                used_date: "", // Data użycia
                used_by: "", // Kto zwalidował (ID pracownika)
                validation_count: 0, // Ile razy zwalidowany (może być wielokrotny wstęp)
                validation_max: 1, // Maksymalna liczba walidacji
                validation_history: [ // Historia walidacji
                  {
                    validated_date: "2024-08-15 18:15:00",
                    validated_by: "STAFF001",
                    validated_location: "Gate A",
                    validation_type: "entry" // entry, exit, re-entry
                  }
                ],
                is_cancelled: 0, // Czy anulowany
                cancelled_date: "", // Data anulowania
                cancelled_reason: "", // Powód anulowania
                is_refunded: 0, // Czy zwrócono pieniądze
                refund_date: "", // Data zwrotu
                                refund_requested: 0, // Czy zwrot został zgłoszony
                refund_rejected: 0, // Czy wniosek o zwrot został odrzucony
                refund_rejected_reason: "", // Powód odrzucenia zwrotu
                refund_amount: 0, // Kwota zwrotu
                refund_policy: "refundable_30_days", // Polityka zwrotów: refundable_30_days, non_refundable, refundable_until_event

                // === QR CODE & SECURITY ===
                qr_code: "MUZIBLE-TICKET-2024-EVT001-0001-SECURE-HASH-12345", // Kod do generowania QR
                qr_code_hash: "sha256:a3d8f7e2...", // Hash QR kodu (dla bezpieczeństwa)
                security_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // JWT token do walidacji
                encryption_enabled: 1, // Czy QR jest szyfrowany

                // === DODATKI & UPRAWNIENIA ===
                perks: [ // Lista dodatkowych uprawnień
                  {
                    perk_id: "PERK001",
                    perk_type: "backstage_pass", // backstage_pass, meet_greet, free_drink, parking, merch_discount
                    perk_name: "Backstage Pass",
                    perk_description: "Access to backstage area after main show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:00:00",
                    perk_valid_until: "2024-08-16 01:00:00"
                  },
                  {
                    perk_id: "PERK002",
                    perk_type: "meet_greet",
                    perk_name: "Meet & Greet",
                    perk_description: "Meet the artists after the show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:30:00",
                    perk_valid_until: "2024-08-15 23:30:00"
                  },
                  {
                    perk_id: "PERK003",
                    perk_type: "free_drink",
                    perk_name: "2 Free Drinks",
                    perk_description: "2 complimentary drinks at VIP bar",
                    perk_quantity: 2,
                    perk_quantity_used: 0,
                    perk_used: 0
                  }
                ],

                // === MEDIA ===
                // Docelowe linki
                //image_full: "https://cdn-img.muzible.com/tickets/TICKET001/full.webp", // Pełny obraz biletu
                //image_thumb: "https://cdn-img.muzible.com/tickets/TICKET001/thumb_200x200.webp", // Miniatura
                //image_qr: "https://cdn-img.muzible.com/tickets/TICKET001/qr.webp", // Wygenerowany QR kod (opcjonalnie)
                //event_image: "https://cdn-img.muzible.com/events/EVENT001/poster.webp", // Plakat wydarzenia

                image_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT008.webp", // Pełny obraz biletu
                image_thumb: "https://cdn-img.muzible.com/tracks/default/DEFAULT008_200x200.webp", // Miniatura
                image_qr: "https://cdn-img.muzible.com/tracks/default/DEFAULT012_200x200.jpg", // Wygenerowany QR kod (opcjonalnie)
                event_image: "https://cdn-img.muzible.com/tracks/default/DEFAULT011.webp", // Plakat wydarzenia

                // === PROMOCYJNY UTWÓR ===
                promo_track_id: "DEFAULT001", // ID utworu promocyjnego (pobierany z API)
                promo_track_unlocked: 0, // Czy odblokowany (może być bonus za zakup)
                promo_track_playable: 1, // Czy można odtworzyć

                // === METADANE ===
                created_at: "2024-01-15 12:30:00",
                updated_at: "2024-01-15 12:30:00",
                version: 1, // Wersja struktury (na przyszłość)
                notes: "", // Dodatkowe notatki (dla admina/organizatora)
                tags: ["vip", "festival", "summer", "2024"], // Tagi dla łatwiejszego wyszukiwania
                
                // === INNE ===
                language: "en", // Język biletu
                terms_url: "https://muzible.com/terms", // Link do regulaminu
                privacy_url: "https://muzible.com/privacy", // Link do polityki prywatności
              },
                            {
                // === PODSTAWOWE INFO ===
                id: "TICKET001", // Unikalny ID biletu
                ticket_number: "2025-EVT001-0001", // Numer biletu (human-readable)
                event_id: "EVENT001", // ID wydarzenia
                event_name: "Muzible Jazz Festival 2025", // Nazwa wydarzenia
                event_description: "The biggest music festival of the year featuring 50+ artists", // Opis wydarzenia
                event_location: "National Stadium, Warsaw", // Miejsce wydarzenia
                event_location_address: "Poniatowskiego 1, 00-001 Warsaw, Poland", // Adres
                event_location_gps: {
                  lat: "52.2394845",
                  lon: "21.0458205"
                },
                event_location_map_link: "https://maps.google.com/?q=52.2394845,21.0458205", // Link do mapy
                event_date: "2024-08-15", // Data wydarzenia (YYYY-MM-DD)
                event_time_start: "18:00", // Czas rozpoczęcia
                event_time_end: "23:59", // Czas zakończenia
                event_timezone: "Europe/Warsaw", // Strefa czasowa

                // === INFO O BILECIE ===
                ticket_type: "VIP", // Typ: VIP, Standard, Early Bird, Premium, etc.
                ticket_category: "standing", // Kategoria: standing, seated, vip_lounge
                ticket_section: "A", // Sektor (jeśli applicable)
                ticket_row: "12", // Rząd (jeśli seated)
                ticket_seat: "45", // Miejsce (jeśli seated)
                ticket_description: "Full access VIP ticket with backstage pass and meet & greet", // Opis biletu
                ticket_valid_from: "2024-08-15 16:00:00", // Od kiedy ważny
                ticket_valid_until: "2024-08-16 02:00:00", // Do kiedy ważny
                
                // === WŁAŚCICIEL ===
                owner_id: "160nahwyn4", // ID aktualnego właściciela (user ID)
                owner_email: "tomasz.andel@gmail.com", // Email właściciela
                owner_verse_username: "Andel_Tomasz",
                owner_name: "", // Imię i nazwisko (jeśli non-transferable ticket)
                owner_surname: "", // Nazwisko (jeśli non-transferable ticket)
                owner_history: [ // Historia właścicieli (dla NFT)
                  {
                    owner_id: "160nahwyn4",
                    owner_email: "tomasz.andel@gmail.com",
                    owner_verse_username: "Andel_Tomasz",
                    acquired_date: "2024-01-15 12:30:00",
                    acquired_price_usd: 150,
                    acquired_price_muz: 0,
                    acquired_method: "purchase" // purchase, transfer, claim, airdrop
                  }
                ],

                // === ORGANIZATOR ===
                issuer_id: "ORG001", // ID organizatora
                issuer_name: "Muzible Events", // Nazwa organizatora
                issuer_email: "events@muzible.com", // Email organizatora
                issuer_verified: 1, // Czy zweryfikowany organizator
                issue_date: "2024-01-15 12:30:00", // Data wystawienia biletu
                issue_timestamp: "2024-01-15T12:30:00.000Z", // Timestamp wystawienia

                // === CENA & PŁATNOŚĆ ===
                price_paid_usd: 150, // Cena zapłacona w USD
                price_paid_eur: 0, // Cena zapłacona w EUR
                price_paid_pln: 0, // Cena zapłacona w PLN
                price_paid_muz: 0, // Cena zapłacona w MUZ
                price_paid_eth: 0, // Cena zapłacona w ETH
                price_paid_btc: 0, // Cena zapłacona w BTC
                price_original_usd: 150, // Oryginalna cena (mogła być promocja)
                payment_currency: "USD", // W jakiej walucie zapłacono
                payment_method: "stripe", // Metoda płatności: stripe, paypal, metamask, crypto
                payment_transaction_id: "pi_3KxJ....", // ID transakcji płatności
                payment_date: "2024-01-15 12:30:00", // Data płatności

                // === NFT INFO ===
                is_nft: 1, // Czy jest NFT (1) czy zwykłym biletem (0)
                is_transferable: 1, // Czy można przenieść (1) czy jest personalizowany (0)
                transfer_count: 0, // Ile razy został przeniesiony
                transfer_max: 3, // Maksymalna liczba transferów (-1 = unlimited)
                is_resellable: 1, // Czy można wystawić na sprzedaż
                is_listed_for_sale: 0, // Czy wysatwione aktualnie na sprzedaz
                resale_royalty_percent: 10, // Procent dla organizatora przy odsprzedaży
                resale_current_price_usd: 0, // Aktualna cena na sprzedaż (0 = nie na sprzedaż)
                resale_current_price_muz: 0, // Aktualna cena w MUZ
                resale_current_price_eur: 0,
                resale_current_price_pln: 0,
                resale_current_price_btc: 0,
                resale_current_price_eth: 0,
                resale_history: [ // Historia cen sprzedaży
                ],
                
                // === BLOCKCHAIN (jeśli NFT) ===
                blockchain_chain: "polygon", // Chain: polygon, ethereum, base
                blockchain_contract: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb", // Adres smart contract
                blockchain_token_id: "1234567890", // Token ID na blockchainie
                blockchain_tx_hash: "0x9fc76417374aa880d4449a1f7f31ec597f00b1f6f3dd2d66f4c9c6c445836d8b", // Hash transakcji mint
                blockchain_owner_address: "0x71ce6f682075458492c4ed33c6f2705BC83E2AD7", // Adres walleta właściciela
                blockchain_metadata_uri: "ipfs://QmZ4tDuvesekSs4qM5ZBKpXiZGun7S2CYtEZRB3DYXkjGx", // URI do metadanych NFT

                // === WALIDACJA & STATUS ===
                status: "used", // Status: active, used, cancelled, refunded, expired
                is_used: 1, // Czy został użyty
                used_date: "2024-08-15 18:15:00", // Data użycia
                used_by: "STAFF001", // Kto zwalidował (ID pracownika)
                validation_count: 1, // Ile razy zwalidowany (może być wielokrotny wstęp)
                validation_max: 3, // Maksymalna liczba walidacji
                validation_history: [ // Historia walidacji
                  {
                    validated_date: "2024-08-15 18:15:00",
                    validated_by: "STAFF001",
                    validated_location: "Gate A",
                    validation_type: "entry" // entry, exit, re-entry
                  }
                ],
                is_cancelled: 0, // Czy anulowany
                cancelled_date: "", // Data anulowania
                cancelled_reason: "", // Powód anulowania
                is_refunded: 0, // Czy zwrócono pieniądze
                refund_date: "", // Data zwrotu
                                refund_requested: 0, // Czy zwrot został zgłoszony
                refund_rejected: 0, // Czy wniosek o zwrot został odrzucony
                refund_rejected_reason: "", // Powód odrzucenia zwrotu
                refund_amount: 0, // Kwota zwrotu
                refund_policy: "refundable_30_days", // Polityka zwrotów: refundable_30_days, non_refundable, refundable_until_event

                // === QR CODE & SECURITY ===
                qr_code: "MUZIBLE-TICKET-2024-EVT001-0001-SECURE-HASH-12345", // Kod do generowania QR
                qr_code_hash: "sha256:a3d8f7e2...", // Hash QR kodu (dla bezpieczeństwa)
                security_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // JWT token do walidacji
                encryption_enabled: 1, // Czy QR jest szyfrowany

                // === DODATKI & UPRAWNIENIA ===
                perks: [ // Lista dodatkowych uprawnień
                  {
                    perk_id: "PERK001",
                    perk_type: "backstage_pass", // backstage_pass, meet_greet, free_drink, parking, merch_discount
                    perk_name: "Backstage Pass",
                    perk_description: "Access to backstage area after main show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:00:00",
                    perk_valid_until: "2024-08-16 01:00:00"
                  },
                  {
                    perk_id: "PERK002",
                    perk_type: "meet_greet",
                    perk_name: "Meet & Greet",
                    perk_description: "Meet the artists after the show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:30:00",
                    perk_valid_until: "2024-08-15 23:30:00"
                  },
                  {
                    perk_id: "PERK003",
                    perk_type: "free_drink",
                    perk_name: "2 Free Drinks",
                    perk_description: "2 complimentary drinks at VIP bar",
                    perk_quantity: 2,
                    perk_quantity_used: 0,
                    perk_used: 0
                  }
                ],

                // === MEDIA ===
                // Docelowe linki
                //image_full: "https://cdn-img.muzible.com/tickets/TICKET001/full.webp", // Pełny obraz biletu
                //image_thumb: "https://cdn-img.muzible.com/tickets/TICKET001/thumb_200x200.webp", // Miniatura
                //image_qr: "https://cdn-img.muzible.com/tickets/TICKET001/qr.webp", // Wygenerowany QR kod (opcjonalnie)
                //event_image: "https://cdn-img.muzible.com/events/EVENT001/poster.webp", // Plakat wydarzenia

                image_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT008.webp", // Pełny obraz biletu
                image_thumb: "https://cdn-img.muzible.com/tracks/default/DEFAULT008_200x200.webp", // Miniatura
                image_qr: "https://cdn-img.muzible.com/tracks/default/DEFAULT012_200x200.jpg", // Wygenerowany QR kod (opcjonalnie)
                event_image: "https://cdn-img.muzible.com/tracks/default/DEFAULT011.webp", // Plakat wydarzenia

                // === PROMOCYJNY UTWÓR ===
                promo_track_id: "DEFAULT001", // ID utworu promocyjnego (pobierany z API)
                promo_track_unlocked: 0, // Czy odblokowany (może być bonus za zakup)
                promo_track_playable: 1, // Czy można odtworzyć

                // === METADANE ===
                created_at: "2024-01-15 12:30:00",
                updated_at: "2024-01-15 12:30:00",
                version: 1, // Wersja struktury (na przyszłość)
                notes: "", // Dodatkowe notatki (dla admina/organizatora)
                tags: ["vip", "festival", "summer", "2024"], // Tagi dla łatwiejszego wyszukiwania
                
                // === INNE ===
                language: "en", // Język biletu
                terms_url: "https://muzible.com/terms", // Link do regulaminu
                privacy_url: "https://muzible.com/privacy", // Link do polityki prywatności
              },
                            {
                // === PODSTAWOWE INFO ===
                id: "TICKET001", // Unikalny ID biletu
                ticket_number: "2023-EVT001-0001", // Numer biletu (human-readable)
                event_id: "EVENT003", // ID wydarzenia
                event_name: "Muzible Live Festival 2023", // Nazwa wydarzenia
                event_description: "The biggest music festival of the year featuring 50+ artists", // Opis wydarzenia
                event_location: "National Stadium, Warsaw", // Miejsce wydarzenia
                event_location_address: "Poniatowskiego 1, 00-001 Warsaw, Poland", // Adres
                event_location_gps: {
                  lat: "52.2394845",
                  lon: "21.0458205"
                },
                event_location_map_link: "https://maps.google.com/?q=52.2394845,21.0458205", // Link do mapy
                event_date: "2025-11-16", // Data wydarzenia (YYYY-MM-DD)
                event_time_start: "00:00", // Czas rozpoczęcia
                event_time_end: "02:59", // Czas zakończenia
                event_timezone: "Europe/Warsaw", // Strefa czasowa

                // === INFO O BILECIE ===
                ticket_type: "VIP", // Typ: VIP, Standard, Early Bird, Premium, etc.
                ticket_category: "standing", // Kategoria: standing, seated, vip_lounge
                ticket_section: "A", // Sektor (jeśli applicable)
                ticket_row: "12", // Rząd (jeśli seated)
                ticket_seat: "45", // Miejsce (jeśli seated)
                ticket_description: "Full access VIP ticket with backstage pass and meet & greet", // Opis biletu
                ticket_valid_from: "2024-08-15 16:00:00", // Od kiedy ważny
                ticket_valid_until: "2024-08-16 02:00:00", // Do kiedy ważny
                
                // === WŁAŚCICIEL ===
                owner_id: "160nahwyn4", // ID aktualnego właściciela (user ID)
                owner_email: "tomasz.andel@gmail.com", // Email właściciela
                owner_verse_username: "Andel_Tomasz",
                owner_name: "", // Imię i nazwisko (jeśli non-transferable ticket)
                owner_surname: "", // Nazwisko (jeśli non-transferable ticket)
                owner_history: [ // Historia właścicieli (dla NFT)
                  {
                    owner_id: "160nahwyn4",
                    owner_email: "tomasz.andel@gmail.com",
                    owner_verse_username: "Andel_Tomasz",
                    acquired_date: "2024-01-15 12:30:00",
                    acquired_price_usd: 150,
                    acquired_price_muz: 0,
                    acquired_method: "purchase" // purchase, transfer, claim, airdrop
                  }
                ],

                // === ORGANIZATOR ===
                issuer_id: "ORG001", // ID organizatora
                issuer_name: "Muzible Events", // Nazwa organizatora
                issuer_email: "events@muzible.com", // Email organizatora
                issuer_verified: 1, // Czy zweryfikowany organizator
                issue_date: "2024-01-15 12:30:00", // Data wystawienia biletu
                issue_timestamp: "2024-01-15T12:30:00.000Z", // Timestamp wystawienia

                // === CENA & PŁATNOŚĆ ===
                price_paid_usd: 150, // Cena zapłacona w USD
                price_paid_eur: 0, // Cena zapłacona w EUR
                price_paid_pln: 0, // Cena zapłacona w PLN
                price_paid_muz: 0, // Cena zapłacona w MUZ
                price_paid_eth: 0, // Cena zapłacona w ETH
                price_paid_btc: 0, // Cena zapłacona w BTC
                price_original_usd: 150, // Oryginalna cena (mogła być promocja)
                payment_currency: "USD", // W jakiej walucie zapłacono
                payment_method: "stripe", // Metoda płatności: stripe, paypal, metamask, crypto
                payment_transaction_id: "pi_3KxJ....", // ID transakcji płatności
                payment_date: "2024-01-15 12:30:00", // Data płatności

                // === NFT INFO ===
                is_nft: 0, // Czy jest NFT (1) czy zwykłym biletem (0)
                is_transferable: 0, // Czy można przenieść (1) czy jest personalizowany (0)
                transfer_count: 0, // Ile razy został przeniesiony
                transfer_max: 0, // Maksymalna liczba transferów (-1 = unlimited)
                is_resellable: 0, // Czy można wystawić na sprzedaż
                is_listed_for_sale: 0, // Czy wysatwione aktualnie na sprzedaz
                resale_royalty_percent: 10, // Procent dla organizatora przy odsprzedaży
                resale_current_price_usd: 0, // Aktualna cena na sprzedaż (0 = nie na sprzedaż)
                resale_current_price_muz: 0, // Aktualna cena w MUZ
                resale_current_price_eur: 0,
                resale_current_price_pln: 0,
                resale_current_price_btc: 0,
                resale_current_price_eth: 0,
                resale_history: [ // Historia cen sprzedaży
                ],
                
                // === BLOCKCHAIN (jeśli NFT) ===
                blockchain_chain: "polygon", // Chain: polygon, ethereum, base
                blockchain_contract: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb", // Adres smart contract
                blockchain_token_id: "1234567890", // Token ID na blockchainie
                blockchain_tx_hash: "0x9fc76417374aa880d4449a1f7f31ec597f00b1f6f3dd2d66f4c9c6c445836d8b", // Hash transakcji mint
                blockchain_owner_address: "0x71ce6f682075458492c4ed33c6f2705BC83E2AD7", // Adres walleta właściciela
                blockchain_metadata_uri: "ipfs://QmZ4tDuvesekSs4qM5ZBKpXiZGun7S2CYtEZRB3DYXkjGx", // URI do metadanych NFT

                // === WALIDACJA & STATUS ===
                status: "cancelled", // Status: active, used, cancelled, refunded
                is_used: 0, // Czy został użyty
                used_date: "", // Data użycia
                used_by: "", // Kto zwalidował (ID pracownika)
                validation_count: 0, // Ile razy zwalidowany (może być wielokrotny wstęp)
                validation_max: 1, // Maksymalna liczba walidacji
                validation_history: [ // Historia walidacji

                ],
                is_cancelled: 1, // Czy anulowany
                cancelled_date: "2024-01-15 14:30:00", // Data anulowania
                cancelled_reason: "Event Cancelled because of bad mood", // Powód anulowania
                is_refunded: 0, // Czy zwrócono pieniądze
                refund_date: "", // Data zwrotu
                                refund_requested: 0, // Czy zwrot został zgłoszony
                refund_rejected: 0, // Czy wniosek o zwrot został odrzucony
                refund_rejected_reason: "", // Powód odrzucenia zwrotu
                refund_amount: 0, // Kwota zwrotu
                refund_policy: "refundable_30_days", // Polityka zwrotów: refundable_30_days, non_refundable, refundable_until_event

                // === QR CODE & SECURITY ===
                qr_code: "MUZIBLE-TICKET-2024-EVT001-0001-SECURE-HASH-12345", // Kod do generowania QR
                qr_code_hash: "sha256:a3d8f7e2...", // Hash QR kodu (dla bezpieczeństwa)
                security_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // JWT token do walidacji
                encryption_enabled: 1, // Czy QR jest szyfrowany

                // === DODATKI & UPRAWNIENIA ===
                perks: [ // Lista dodatkowych uprawnień
                  {
                    perk_id: "PERK001",
                    perk_type: "backstage_pass", // backstage_pass, meet_greet, free_drink, parking, merch_discount
                    perk_name: "Backstage Pass",
                    perk_description: "Access to backstage area after main show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:00:00",
                    perk_valid_until: "2024-08-16 01:00:00"
                  },
                  {
                    perk_id: "PERK002",
                    perk_type: "meet_greet",
                    perk_name: "Meet & Greet",
                    perk_description: "Meet the artists after the show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:30:00",
                    perk_valid_until: "2024-08-15 23:30:00"
                  },
                  {
                    perk_id: "PERK003",
                    perk_type: "free_drink",
                    perk_name: "2 Free Drinks",
                    perk_description: "2 complimentary drinks at VIP bar",
                    perk_quantity: 2,
                    perk_quantity_used: 0,
                    perk_used: 0
                  }
                ],

                // === MEDIA ===
                // Docelowe linki
                //image_full: "https://cdn-img.muzible.com/tickets/TICKET001/full.webp", // Pełny obraz biletu
                //image_thumb: "https://cdn-img.muzible.com/tickets/TICKET001/thumb_200x200.webp", // Miniatura
                //image_qr: "https://cdn-img.muzible.com/tickets/TICKET001/qr.webp", // Wygenerowany QR kod (opcjonalnie)
                //event_image: "https://cdn-img.muzible.com/events/EVENT001/poster.webp", // Plakat wydarzenia

                image_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT008.webp", // Pełny obraz biletu
                image_thumb: "https://cdn-img.muzible.com/tracks/default/DEFAULT008_200x200.webp", // Miniatura
                image_qr: "https://cdn-img.muzible.com/tracks/default/DEFAULT012_200x200.jpg", // Wygenerowany QR kod (opcjonalnie)
                event_image: "https://cdn-img.muzible.com/tracks/default/DEFAULT011.webp", // Plakat wydarzenia

                // === PROMOCYJNY UTWÓR ===
                promo_track_id: "DEFAULT001", // ID utworu promocyjnego (pobierany z API)
                promo_track_unlocked: 1, // Czy odblokowany (może być bonus za zakup)
                promo_track_playable: 1, // Czy można odtworzyć

                // === METADANE ===
                created_at: "2024-01-15 12:30:00",
                updated_at: "2024-01-15 12:30:00",
                version: 1, // Wersja struktury (na przyszłość)
                notes: "", // Dodatkowe notatki (dla admina/organizatora)
                tags: ["vip", "festival", "summer", "2024"], // Tagi dla łatwiejszego wyszukiwania
                
                // === INNE ===
                language: "en", // Język biletu
                terms_url: "https://muzible.com/terms", // Link do regulaminu
                privacy_url: "https://muzible.com/privacy", // Link do polityki prywatności
              },
                            {
                // === PODSTAWOWE INFO ===
                id: "TICKET001", // Unikalny ID biletu
                ticket_number: "2025-EVT002-0001", // Numer biletu (human-readable)
                event_id: "EVENT002", // ID wydarzenia
                event_name: "Muzible Live Festival 2025", // Nazwa wydarzenia
                event_description: "The biggest music festival of the year featuring 50+ artists", // Opis wydarzenia
                event_location: "National Stadium, Warsaw", // Miejsce wydarzenia
                event_location_address: "Poniatowskiego 1, 00-001 Warsaw, Poland", // Adres
                event_location_gps: {
                  lat: "52.2394845",
                  lon: "21.0458205"
                },
                event_location_map_link: "https://maps.google.com/?q=52.2394845,21.0458205", // Link do mapy
                event_date: "2024-08-15", // Data wydarzenia (YYYY-MM-DD)
                event_time_start: "18:00", // Czas rozpoczęcia
                event_time_end: "23:59", // Czas zakończenia
                event_timezone: "Europe/Warsaw", // Strefa czasowa

                // === INFO O BILECIE ===
                ticket_type: "Premium", // Typ: VIP, Standard, Early Bird, Premium, etc.
                ticket_category: "standing", // Kategoria: standing, seated, vip_lounge
                ticket_section: "A", // Sektor (jeśli applicable)
                ticket_row: "", // Rząd (jeśli seated)
                ticket_seat: "", // Miejsce (jeśli seated)
                ticket_description: "Full access VIP ticket with backstage pass and meet & greet", // Opis biletu
                ticket_valid_from: "2024-08-15 16:00:00", // Od kiedy ważny
                ticket_valid_until: "2024-08-16 02:00:00", // Do kiedy ważny
                
                // === WŁAŚCICIEL ===
                owner_id: "160nahwyn4", // ID aktualnego właściciela (user ID)
                owner_email: "tomasz.andel@gmail.com", // Email właściciela
                owner_verse_username: "",
                owner_name: "", // Imię i nazwisko (jeśli non-transferable ticket)
                owner_surname: "", // Nazwisko (jeśli non-transferable ticket)
                owner_history: [ // Historia właścicieli (dla NFT)
                  {
                    owner_id: "160nahwyn4",
                    owner_email: "tomasz.andel@gmail.com",
                    owner_verse_username: "",
                    acquired_date: "2024-01-15 12:30:00",
                    acquired_price_usd: 150,
                    acquired_price_muz: 0,
                    acquired_method: "purchase" // purchase, transfer, claim, airdrop
                  }
                ],

                // === ORGANIZATOR ===
                issuer_id: "ORG001", // ID organizatora
                issuer_name: "Muzible Events", // Nazwa organizatora
                issuer_email: "events@muzible.com", // Email organizatora
                issuer_verified: 1, // Czy zweryfikowany organizator
                issue_date: "2024-01-15 12:30:00", // Data wystawienia biletu
                issue_timestamp: "2024-01-15T12:30:00.000Z", // Timestamp wystawienia

                // === CENA & PŁATNOŚĆ ===
                price_paid_usd: 150, // Cena zapłacona w USD
                price_paid_eur: 0, // Cena zapłacona w EUR
                price_paid_pln: 0, // Cena zapłacona w PLN
                price_paid_muz: 0, // Cena zapłacona w MUZ
                price_paid_eth: 0, // Cena zapłacona w ETH
                price_paid_btc: 0, // Cena zapłacona w BTC
                price_original_usd: 150, // Oryginalna cena (mogła być promocja)
                payment_currency: "USD", // W jakiej walucie zapłacono
                payment_method: "stripe", // Metoda płatności: stripe, paypal, metamask, crypto
                payment_transaction_id: "pi_3KxJ....", // ID transakcji płatności
                payment_date: "2024-01-15 12:30:00", // Data płatności

                // === NFT INFO ===
                is_nft: 1, // Czy jest NFT (1) czy zwykłym biletem (0)
                is_transferable: 1, // Czy można przenieść (1) czy jest personalizowany (0)
                transfer_count: 0, // Ile razy został przeniesiony
                transfer_max: 3, // Maksymalna liczba transferów (-1 = unlimited)
                is_resellable: 1, // Czy można wystawić na sprzedaż
                is_listed_for_sale: 0, // Czy wysatwione aktualnie na sprzedaz
                resale_royalty_percent: 10, // Procent dla organizatora przy odsprzedaży
                resale_current_price_usd: 0, // Aktualna cena na sprzedaż (0 = nie na sprzedaż)
                resale_current_price_muz: 0, // Aktualna cena w MUZ
                resale_current_price_eur: 0,
                resale_current_price_pln: 0,
                resale_current_price_btc: 0,
                resale_current_price_eth: 0,
                resale_history: [ // Historia cen sprzedaży
                ],
                
                // === BLOCKCHAIN (jeśli NFT) ===
                blockchain_chain: "polygon", // Chain: polygon, ethereum, base
                blockchain_contract: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb", // Adres smart contract
                blockchain_token_id: "1234567890", // Token ID na blockchainie
                blockchain_tx_hash: "0x9fc76417374aa880d4449a1f7f31ec597f00b1f6f3dd2d66f4c9c6c445836d8b", // Hash transakcji mint
                blockchain_owner_address: "0x71ce6f682075458492c4ed33c6f2705BC83E2AD7", // Adres walleta właściciela
                blockchain_metadata_uri: "ipfs://QmZ4tDuvesekSs4qM5ZBKpXiZGun7S2CYtEZRB3DYXkjGx", // URI do metadanych NFT

                // === WALIDACJA & STATUS ===
                status: "refunded", // Status: active, used, cancelled, refunded, expired
                is_used: 0, // Czy został użyty
                used_date: "", // Data użycia
                used_by: "", // Kto zwalidował (ID pracownika)
                validation_count: 0, // Ile razy zwalidowany (może być wielokrotny wstęp)
                validation_max: 1, // Maksymalna liczba walidacji
                validation_history: [ // Historia walidacji

                ],
                is_cancelled: 1, // Czy anulowany
                cancelled_date: "2024-08-15 18:15:00", // Data anulowania
                cancelled_reason: "Event Canceled", // Powód anulowania
                is_refunded: 1, // Czy zwrócono pieniądze
                refund_date: "2024-08-20 10:00:00", // Data zwrotu
                                refund_requested: 1, // Czy zwrot został zgłoszony
                refund_rejected: 0, // Czy wniosek o zwrot został odrzucony
                refund_rejected_reason: "", // Powód odrzucenia zwrotu
                refund_amount: 100, // Kwota zwrotu
                refund_policy: "refundable_30_days", // Polityka zwrotów: refundable_30_days, non_refundable, refundable_until_event

                // === QR CODE & SECURITY ===
                qr_code: "MUZIBLE-TICKET-2024-EVT001-0001-SECURE-HASH-12345", // Kod do generowania QR
                qr_code_hash: "sha256:a3d8f7e2...", // Hash QR kodu (dla bezpieczeństwa)
                security_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...", // JWT token do walidacji
                encryption_enabled: 1, // Czy QR jest szyfrowany

                // === DODATKI & UPRAWNIENIA ===
                perks: [ // Lista dodatkowych uprawnień
                  {
                    perk_id: "PERK001",
                    perk_type: "backstage_pass", // backstage_pass, meet_greet, free_drink, parking, merch_discount
                    perk_name: "Backstage Pass",
                    perk_description: "Access to backstage area after main show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:00:00",
                    perk_valid_until: "2024-08-16 01:00:00"
                  },
                  {
                    perk_id: "PERK002",
                    perk_type: "meet_greet",
                    perk_name: "Meet & Greet",
                    perk_description: "Meet the artists after the show",
                    perk_used: 0,
                    perk_used_date: "",
                    perk_valid_from: "2024-08-15 22:30:00",
                    perk_valid_until: "2024-08-15 23:30:00"
                  },
                  {
                    perk_id: "PERK003",
                    perk_type: "free_drink",
                    perk_name: "2 Free Drinks",
                    perk_description: "2 complimentary drinks at VIP bar",
                    perk_quantity: 2,
                    perk_quantity_used: 0,
                    perk_used: 0
                  }
                ],

                // === MEDIA ===
                // Docelowe linki
                //image_full: "https://cdn-img.muzible.com/tickets/TICKET001/full.webp", // Pełny obraz biletu
                //image_thumb: "https://cdn-img.muzible.com/tickets/TICKET001/thumb_200x200.webp", // Miniatura
                //image_qr: "https://cdn-img.muzible.com/tickets/TICKET001/qr.webp", // Wygenerowany QR kod (opcjonalnie)
                //event_image: "https://cdn-img.muzible.com/events/EVENT001/poster.webp", // Plakat wydarzenia

                image_full: "https://cdn-img.muzible.com/tracks/default/DEFAULT008.webp", // Pełny obraz biletu
                image_thumb: "https://cdn-img.muzible.com/tracks/default/DEFAULT008_200x200.webp", // Miniatura
                image_qr: "https://cdn-img.muzible.com/tracks/default/DEFAULT012_200x200.jpg", // Wygenerowany QR kod (opcjonalnie)
                event_image: "https://cdn-img.muzible.com/tracks/default/DEFAULT011.webp", // Plakat wydarzenia

                // === PROMOCYJNY UTWÓR ===
                promo_track_id: "DEFAULT001", // ID utworu promocyjnego (pobierany z API)
                promo_track_unlocked: 0, // Czy odblokowany (może być bonus za zakup)
                promo_track_playable: 1, // Czy można odtworzyć

                // === METADANE ===
                created_at: "2024-01-15 12:30:00",
                updated_at: "2024-01-15 12:30:00",
                version: 1, // Wersja struktury (na przyszłość)
                notes: "", // Dodatkowe notatki (dla admina/organizatora)
                tags: ["vip", "festival", "summer", "2024"], // Tagi dla łatwiejszego wyszukiwania
                
                // === INNE ===
                language: "en", // Język biletu
                terms_url: "https://muzible.com/terms", // Link do regulaminu
                privacy_url: "https://muzible.com/privacy", // Link do polityki prywatności
              }
            ]
          }
          commit('SET_USER_TICKETS', data)
          const promise = Promise.resolve(data);
          return promise;
          */

            try {
                const response = await EventService.getTickets({
                  token: credentials.token,
                  page: credentials.page || 1,
                  limit: credentials.limit || 10
                });

                if (response && response.data) {
                    commit('SET_USER_TICKETS', response.data)
                    return response.data;
                }

                return null;
              } catch (error) {
                console.error('Store getTickets error:', error);
                throw error;
              }
        },
          getCollectionsNFT: ({ commit }, credentials) => {
          
          /*var data = {
            collections: []
          }
          commit('SET_USER_COLLECTIONS', data)
          const promise = Promise.resolve(data);
          return promise;*/

          return EventService.getCollectionsNFT(credentials)
          .then(({ data }) => {
            commit('SET_USER_COLLECTIONS', data)
          })
        },
        transferTicket: ({ commit }, credentials) => {
          return EventService.transferTicket(credentials)
        },
        getCollectionsMusic: ({ commit }, credentials) => {
          /*var data = {
            collections: []
          }
          commit('SET_USER_COLLECTIONS_MUSIC', data)
          const promise = Promise.resolve(data);
          return promise;*/

          return EventService.getCollectionsMusic(credentials)
          .then(({ data }) => {
            commit('SET_USER_COLLECTIONS_MUSIC', data)
          })
        },
        getSubscriptions: ({ commit }, credentials) => {
          /*var data = {
            subscriptions: []
          }
          commit('SET_USER_SUBSCRIPTIONS', data)
          const promise = Promise.resolve(data);
          return promise;*/

          return EventService.getSubscriptions(credentials)
          .then(({ data }) => {
            commit('SET_USER_SUBSCRIPTIONS', data)
          })
        },
        logErrorMedia: ({ commit }, credentials) => {
          /*var data = {
            "ok": 1
          };
          const promise = Promise.resolve(data);
          return promise;*/
          
          return EventService.logErrorMedia(credentials)
        },
        setCurrentTrackIndex: ({ commit }, credentials) => {
          commit('SET_CURRENT_TRACK_INDEX', credentials)
        },
        upload2faFile: ({commit}, credentials) => {
          return EventService.upload2faFile(credentials).then(({data}) => {
            commit('SET_USER_DATA_LS', data)
          })
         },
         upload2faFileRev: ({commit}, credentials) => {
          return EventService.upload2faFileRev(credentials).then(({data}) => {
            commit('SET_USER_DATA_LS', data)
          })
         },
         upload2faFileAddress: ({commit}, credentials) => {
          return EventService.upload2faFileAddress(credentials).then(({data}) => {
            commit('SET_USER_DATA_LS', data)
          })
         },
         upload2faFileCompany: ({commit}, credentials) => {
          return EventService.upload2faFileCompany(credentials).then(({data}) => {
            commit('SET_USER_DATA_LS', data)
          })
         },
         upload2faFileCreator: ({commit}, credentials) => {
          return EventService.upload2faFileCreator(credentials).then(({data}) => {
            commit('SET_USER_DATA_LS', data)
          })
         },
         unsubscribe: ({commit}, credentials) => {
          return EventService.unsubscribe(credentials)
        },
         setUserCreatorVerify: ({commit}, credentials) => {
          return EventService.setUserCreatorVerify(credentials)
         },
         validateTicket: ({commit}, credentials) => {
          var data = {
            "used": 0,
            "info": "Welcome to the event!"
          };
          const promise = Promise.resolve(data);
          return promise;

          //return EventService.validateTicket(credentials)
         },


         // Crypto Start

         getCryptoUserData: ({commit}, credentials) => {
          /*
          var data = {
            "email":"tomasz.andel@gmail.com",
                                                 "uid":"a6yw5go4wi",
                                                 "tokens": 2000,
                                                 "tokens_vested": 1700,
                                                 "transfering": 0, // specify if some token transfer is submitted for execution, block all until its not cleared
                                                 "in_transfer": 100, // number of tokens that are in transfer now, available = tokens - tokens_vested - in_transfer
                                                 "dividend_current":0,
                                                 "dividend_current_per":0,
                                                 "dividend_potential":0,
                                                 "dividend_potential_per":0,
          }
          commit('SET_USER_CRYPTO_DATA', data)
          const promise = Promise.resolve(data);
          return promise;*/

          return EventService.getCryptoUserData(credentials)
                  .then(({data}) => {
                    commit('SET_USER_CRYPTO_DATA', data)
                  })
       },

         getCryptoDashboardData: ({commit}) => {

          /*var data = {
            "total":10000000,
              "released":2000009,
              "burned":1999900,
              "listed":0,
              "listing_price":0.6,   
              "current_price":0.6,                       
              "release_incoming": 1,
              "release_amount":1000000,
              "release_amount_left":99000,
              "release_price":0.3,        
              "market_price":0.5,                  
              "yield_confirmed_date":0,
              "yield_percent":15,
              "yield_from_date":"2022-05-25",
              "yield_date":"2023-02-25",
              "data_live":1,              
          }
          commit('SET_DASHBOARD_DATA', data)
          const promise = Promise.resolve(data);
          return promise;*/


          return EventService.getCryptoDashboardData()
                  .then(({data}) => {
                    commit('SET_DASHBOARD_DATA', data)
                  })
        },
        activateMetamaskWallet: ({commit}) => {
          // handler stored in metamask object
          commit('ACTIVATE_METAMASK_WALLET');
        },
        deactivateMetamaskWallet: ({commit}) => {
            // handler stored in metamask object
            commit('DEACTIVATE_METAMASK_WALLET');
        },
        setMetamaskWallet: ({commit}, data) => {
            commit('SET_METAMASK_WALLET', data);
        },
        setMetamaskBalance: ({commit}, balance) => {
          commit('SET_METAMASK_BALANCE', balance);
        },
        checkandgetMetamaskWallet: ({commit}, info) => {
          /*
          var data = {
            ok: 1,
            new: 1,
            exist: 0,
          };
          if (data.ok){
            commit('SET_METAMASK_WALLETOBJ', data)
          } else {
            commit('SET_METAMASK_WALLETOBJ', null)
          }
          const promise = Promise.resolve(data);
          return promise;
          */
          
           return EventService.checkandgetMetamaskWallet(info)
               .then(( { data } ) => {
                    if (data.ok){
                        commit('SET_METAMASK_WALLETOBJ', data)
                    } else {
                        commit('SET_METAMASK_WALLETOBJ', null)
                    }
                    return data;
               })
          },
          checkMetamaskAddress: ({commit}, address) => {
            var data = {registered: 1};
            const promise = Promise.resolve(data);
            return promise;
          },


          getUserMetamaskWallets: ({commit}, info) => {
            /*var data = {
              addresses: [{address:'0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', since: '2022-05-25'}, 
                          {address:'0x71ce6f682075458492c4ed33c6f2705BC83E2AD8', since: '2022-05-27'},
                          {address:'0x71ce6f682075458492c4ed33c6f2705BC0000700', since: '2022-09-01'}],
              //addresses: [],
            };
            commit('SET_USER_METAMASK_WALLETS', data)
            const promise = Promise.resolve(data);
            return promise;*/

            return EventService.getUserMetamaskWallets(info)
            .then(( {data} )=> {
                commit('SET_USER_METAMASK_WALLETS', data)
            })
          },

          removeMetamaskWallet: ({commit}, info) => {
            //var data = {
            //  removed: 1
            //};
            //const promise = Promise.resolve(data);
            //return promise;

            return EventService.removeMetamaskWallet(info)
          },

          getLifeTokenAddress: ({commit}) => {
            /*var data = {
              address: '0xdAC17F958D2ee523a2206206994597C13D831ec7'// USDT Address
            }
            commit('SET_LIFE_TOKEN_ADDRESS', data)

            const promise = Promise.resolve(data);
            return promise;*/

            return EventService.getLifeTokenAddress()
                    .then(({data}) => {
                      commit('SET_LIFE_TOKEN_ADDRESS', data)
                    })
          }, 

          setdecimals: ({commit}, info) => {
              commit('SET_DECIMALS', info)
          },
          getNFTOffers: ({commit}, info) => {
            /*var data = { 
              offers: []
            }
            commit('SET_NFT_OFFERS', data)
            const promise = Promise.resolve(data);
            return promise;*/ 

            return EventService.getNFTOffers(info)
                    .then(({data}) => {
                      commit('SET_NFT_OFFERS', data)
                    })
          },
          getTransactions: ({commit}, info) => {
            /*var data = {
              transactions: [
                { price: 1, timestamp: '2025-02-16T15:57:04.442Z', type: 'BUY', volume: 1 },
              ]
            }
            commit('SET_TRANSACTIONS', data)
            const promise = Promise.resolve(data);
            return promise;*/

            return EventService.getTransactions(info)
                    .then(({data}) => {
                      commit('SET_TRANSACTIONS', data)
                    })
          },
          getLifeMasterAddress: ({commit}) => {
            /*var data = {
              //address: '0xa1c68b78e399124A36406718847D084EAa389892'// Master Adres test
              address: '0x71ce6f682075458492c4ed33c6f2705BC83E2AD7'// Master Address
            }
            commit('SET_LIFE_MASTER_ADDRESS', data)

            const promise = Promise.resolve(data);
            return promise;*/
            
            return EventService.getLifeMasterAddress()
                    .then(({data}) => {
                      commit('SET_LIFE_MASTER_ADDRESS', data)
                    })
          },

          getLifeTokenABI: ({commit}) => {
            /*var data = {
              abi: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_upgradedAddress","type":"address"}],"name":"deprecate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"deprecated","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_evilUser","type":"address"}],"name":"addBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"upgradedAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"balances","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"maximumFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_maker","type":"address"}],"name":"getBlackListStatus","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"},{"name":"","type":"address"}],"name":"allowed","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"who","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"newBasisPoints","type":"uint256"},{"name":"newMaxFee","type":"uint256"}],"name":"setParams","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"issue","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"redeem","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"basisPointsRate","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"isBlackListed","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_clearedUser","type":"address"}],"name":"removeBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"MAX_UINT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_blackListedUser","type":"address"}],"name":"destroyBlackFunds","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"_initialSupply","type":"uint256"},{"name":"_name","type":"string"},{"name":"_symbol","type":"string"},{"name":"_decimals","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Issue","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Redeem","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"newAddress","type":"address"}],"name":"Deprecate","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"feeBasisPoints","type":"uint256"},{"indexed":false,"name":"maxFee","type":"uint256"}],"name":"Params","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_blackListedUser","type":"address"},{"indexed":false,"name":"_balance","type":"uint256"}],"name":"DestroyedBlackFunds","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_user","type":"address"}],"name":"AddedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"_user","type":"address"}],"name":"RemovedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"}]
            }
            commit('SET_LIFE_TOKEN_ABI', data)

            const promise = Promise.resolve(data);
            return promise;*/

            return EventService.getLifeTokenABI()
                    .then(({data}) => {
                      commit('SET_LIFE_TOKEN_ABI', data)
                    })
          },



        getAccountHistoryWallets: ({commit}, info) => {
          //get 10 last actions, and display info if someoen wants more to contact us
          /*var data = {
            actions: [  
                        {type: 'BUY', from: 'PayPal', amount:'600', date: '2022-04-25'},
                        {type: 'BUY', from: 'Stripe', amount:'600', date: '2022-04-25'},
                        {type: 'BUY', from: 'Metamask', amount:'600', date: '2022-04-25'},
                        {type: 'IN', from: '0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', amount:'200', date: '2022-05-25'}, 
                        {type: 'PAYMENT REJECTED', from: '0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', amount:'100', date: '2022-05-27'},
                        {type: 'PAYMENT EXECUTED', from: '0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', amount:'100', date: '2022-05-27'},
                        {type: 'PAYMENT ORDER', from: '0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', amount:'100', date: '2022-05-27'},
                        {type: 'STAKING IN', from: 'Life1', amount:'20', date: '2022-09-01'},
                        {type: 'STAKING OUT', from: 'Life1', amount:'20', date: '2022-09-02'},
                        {type: 'DIVIDEND', from: 'Life1', amount:'20', date: '2022-09-03'},
                        {type: 'TRANSFER', from: 'tomasz.andel@andells.com', amount:'200', date: '2022-09-06'},
                        {type: 'TRANSFER', from: 'ta@life1.me', amount:'200', date: '2022-09-06'},
                     ]
          };
          commit('SET_ACCOUNT_HISTORY_WALLETS', data)
          const promise = Promise.resolve(data);
          return promise;*/
        
          return EventService.getAccountHistoryWallets(info).then(({data}) => {
              commit('SET_ACCOUNT_HISTORY_WALLETS', data)
          })
        },
        
        sendTokensToUser: ({commit}, info) => {
          // If ok all good, if not ok display info, could be balance, wrong user or something else happened
          //var data = {
          //  ok: 1
          //};
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
        
          return EventService.sendTokensToUser(info)
        },
        
        sendTokensToWallet: ({commit}, info) => {
          //var data = {
          //  ok: 1
          //};
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
          
          return EventService.sendTokensToWallet(info)
        },
        
        getValidTransferIntents: ({commit}, info) => {
          //var data = {
          //  intents: [{intentid:'1111',from: 'tomasz.andel@gmail.com', to:'0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', addressok: 'OK', amount: '10000', status: 'order', available: '1900', date:'2022-09-06'},
          //            {intentid:'1112',from: 'tomasz.andel@gmail.com', to:'0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', addressok: 'OK', amount: '100', status: 'order', available: '1900', date:'2022-09-06'},
          //            {intentid:'1113',from: 'tomasz.andel@gmail.com', to:'0x71ce6f682075458492c4ed33c6f2705BC83E2AD7', addressok: 'OK', amount: '100', status: 'order', available: '1900', date:'2022-09-06'},
          //            {intentid:'1114',from: 'tomasz.andel@gmail.com', to:'0x71ce6f682075458492c4ed33c6f2705BC83E2AD1', addressok: 'NOK', amount: '100', status: 'order', available: '1900', date:'2022-09-06'}],
          //};
          //commit('SET_TRANSFER_INTENTS', data);
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
        
          return EventService.getValidTransferIntents(info)
                  .then(({data}) => {
                    commit('SET_TRANSFER_INTENTS', data)
                  })
        },
        

        setTransferIntentStatus: ({commit}, info) => {
          //var data = {
          //  ok: 1
          //};
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
        
          return EventService.setTransferIntentStatus(info)
        },
        
        moveToStaking: ({commit}, info) => {
          //If ok all good, if not ok display info, could be balance, wrong user or something else happened
          //var data = {
          //  ok: 1
          //};
        
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
        
          return EventService.moveToStaking(info)
        },
        
        moveFromStaking: ({commit}, info) => {
          //If ok all good, if not ok display info, could be balance, wrong user or something else happened
          //var data = {
          //  ok: 1
          //};
        
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
        
          return EventService.moveFromStaking(info)
        },
        
        
        executeMetamaskTokenTransferIntent: ({commit}, info) => {
          //var data = {
          //  ok: 1
          //}
        
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
          return EventService.executeMetamaskTokenTransferIntent(info);
        },
        
        createMetamaskIntentTokenBuy: ({commit}, info) => {
          //var data = {
          //  orderID: '32msi23'
          //}
        
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
          return EventService.createMetamaskIntentTokenBuy(info);
        },
        
        executeMetamaskPaymentTokenIntent: ({commit}, info) => {
          //var data = {
          //  ok: 1
          //}
        
          //const promise = Promise.reject('');
          //const promise = Promise.reject({response:'whatever'});
          //const promise = Promise.resolve(data);
          //return promise;
          return EventService.executeMetamaskPaymentTokenIntent(info);
        },
        
        // End Crypto

        createStripeIntentToken: ({commit}, credentials) => {
          return EventService.createStripeIntentToken(credentials)
         },
         createPaypalIntentToken: ({commit}, credentials) => {
          return EventService.createPaypalIntentToken(credentials)
        },
        executePaypalIntentToken: ({commit}, credentials) => {
          return EventService.executePaypalIntentToken(credentials)
        },

  },
  getters: {
    // Crypto
    getCryptoDashboardData: state => {
      return state.crypto_dashboard_data;
    },
    getCryptoUserData: state => {
      return state.crypto_user_data;
    },
    getMetamaskWallet: state => {
      return state.metamaskObj;
    },
    getValidTransferIntents: state => {
      return state.transferIntents;
    },
    getMetamaskObject: state => {
      return state.metamask;
    },
    getIsMetamaskWalletActive: state => {
      return state.wallet_metamask;
    },
    getMetamaskBalance: state => {
      return state.metamaskBalance;
    },
    getMetamaskIsLoaded: state => {
      return state.wallet_metamask_loaded;
    },
    getLifeTokenAddress: state => {
      return state.lifeTokenAddress;
    },
    getLifeTokenABI: state => {
      return state.lifeabi;
    },
    getDecimals: state => {
      return state.decimals;
    },
    getLifeMasterAddress: state => {
      return state.masteraddress;
    },
    getActiveStatuses: state => {
      return state.activeStatuses;
    },
    // End Crypto
    getUserData: state => {
      return state.user;
    },
    getMuze: state => {
      return state.muze;
    },
    getNFT: state => {
      return state.nft;
    },
    getReferalSource: state => {
      return state.referal_source;
    },
    getReferalMedium: state => {
      return state.referal_medium;
    },
    getReferalCampaign: state => {
      return state.referal_campaign;
    },
    getP2PUser: state => {
      return state.p2puser;
    },
    getP2PUserOffers: state => {
      return state.p2puseroffers;
    },
    getauth2fa: state => {
      return state.auth2fa;
    },
    getpreLoginData: state => {
      return state.preLoginData;
    },
    getUserPlaylists: state => {
      return state.userplaylists;
    },
    getUserExtPlaylists: state => {
      return state.userextplaylists;
    },
    getUserFavSongs: state => {
      return state.userfavsongs;
    },
    getUserCurrentSongs: state => {
      return state.usercurrentsongs;
    },
    getDefaultCurrentSong: state => {
      return state.tracks_1;
    },
    getUserSubscribedCreators: state => {
      return state.usersubcreators;
    },
    getUserSearchResults: state => {
      return state.usersearchresults;
    },

    getPlaylistCreation: (state) => state.playlistcreation,
    getIsPlaying: (state) => state.isPlaying,
    getIsMusicLoading: (state) => state.ismusicloading,
    getCurrentTrackInfo: (state) => state.currentTrackInfo,
    getUseHls: (state) => state.usehls,
    getHlsReady: (state) => state.hlsready,
    getCurrentTrackIndex: (state) => state.currentTrackIndex,
    getTickets: (state) => state.tickets_nft,
    getCollectionsNFT: (state) => state.collections_nft,
    getCollectionsMusic: (state) => state.collections_music,
    getSubscriptions: (state) => state.subscriptions_nft,
    getUserMetamaskWallets: (state) => state.metamaskwallets,
    getAccountHistoryWallets: (state) => state.accounthistorywallets,
    getTransactions: (state) => state.transactions,
    getNFTOffers: (state) => state.nftOffers,
  }
})


export default store
